export const clubs = [
  // Premier League
  { 
    id: 1, 
    name: "Manchester City", 
    country: "England", 
    league: "Premier League", 
    lat: 53.4831, 
    lng: -2.2441, 
    city: "Manchester",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg"
  },
  { 
    id: 2, 
    name: "Manchester United", 
    country: "England", 
    league: "Premier League", 
    lat: 53.4631, 
    lng: -2.2913, 
    city: "Manchester",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7a/Manchester_United_FC_crest.svg"
  },
  { 
    id: 3, 
    name: "Liverpool", 
    country: "England", 
    league: "Premier League", 
    lat: 53.4308, 
    lng: -2.9608, 
    city: "Liverpool",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/0c/Liverpool_FC.svg"
  },
  { 
    id: 4, 
    name: "Chelsea", 
    country: "England", 
    league: "Premier League", 
    lat: 51.4816, 
    lng: -0.1910, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/c/cc/Chelsea_FC.svg"
  },
  { 
    id: 5, 
    name: "Arsenal", 
    country: "England", 
    league: "Premier League", 
    lat: 51.5549, 
    lng: -0.1084, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/53/Arsenal_FC.svg"
  },
  { 
    id: 6, 
    name: "Tottenham", 
    country: "England", 
    league: "Premier League", 
    lat: 51.6042, 
    lng: -0.0665, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/b/b4/Tottenham_Hotspur.svg"
  },
  { 
    id: 7, 
    name: "Newcastle", 
    country: "England", 
    league: "Premier League", 
    lat: 54.9756, 
    lng: -1.6217, 
    city: "Newcastle",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/56/Newcastle_United_Logo.svg"
  },
  { 
    id: 8, 
    name: "Aston Villa", 
    country: "England", 
    league: "Premier League", 
    lat: 52.5092, 
    lng: -1.8849, 
    city: "Birmingham",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9f/Aston_Villa_logo.svg"
  },
  { 
    id: 9, 
    name: "Brighton", 
    country: "England", 
    league: "Premier League", 
    lat: 50.8225, 
    lng: -0.1372, 
    city: "Brighton",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/fd/Brighton_%26_Hove_Albion_logo.svg"
  },
  { 
    id: 10, 
    name: "West Ham", 
    country: "England", 
    league: "Premier League", 
    lat: 51.5389, 
    lng: -0.0166, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/c/c2/West_Ham_United_FC_logo.svg"
  },
  { 
    id: 11, 
    name: "Brentford", 
    country: "England", 
    league: "Premier League", 
    lat: 51.4907, 
    lng: -0.2884, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/2/2a/Brentford_FC_crest.svg"
  },
  { 
    id: 12, 
    name: "Bournemouth", 
    country: "England", 
    league: "Premier League", 
    lat: 50.7352, 
    lng: -1.8383, 
    city: "Bournemouth",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/e5/AFC_Bournemouth_%282013%29.svg"
  },
  { 
    id: 13, 
    name: "Burnley", 
    country: "England", 
    league: "Premier League", 
    lat: 53.7890, 
    lng: -2.2302, 
    city: "Burnley",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/62/Burnley_FC_Logo.svg"
  },
  { 
    id: 14, 
    name: "Crystal Palace", 
    country: "England", 
    league: "Premier League", 
    lat: 51.3983, 
    lng: -0.0854, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/a/a2/Crystal_Palace_FC_logo_%282022%29.svg"
  },
  { 
    id: 15, 
    name: "Everton", 
    country: "England", 
    league: "Premier League", 
    lat: 53.4389, 
    lng: -2.9662, 
    city: "Liverpool",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/Everton_FC_logo.svg"
  },
  { 
    id: 16, 
    name: "Fulham", 
    country: "England", 
    league: "Premier League", 
    lat: 51.4749, 
    lng: -0.2216, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/eb/Fulham_FC_%28shield%29.svg"
  },
  { 
    id: 17, 
    name: "Leeds United", 
    country: "England", 
    league: "Premier League", 
    lat: 53.7777, 
    lng: -1.5719, 
    city: "Leeds",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/54/Leeds_United_F.C._logo.svg"
  },
  { 
    id: 18, 
    name: "Nottingham Forest", 
    country: "England", 
    league: "Premier League", 
    lat: 52.9394, 
    lng: -1.1329, 
    city: "Nottingham",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/e5/Nottingham_Forest_F.C._logo.svg"
  },
  { 
    id: 19, 
    name: "Sunderland", 
    country: "England", 
    league: "Premier League", 
    lat: 54.9069, 
    lng: -1.3838, 
    city: "Sunderland",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/77/Sunderland_AFC_logo.svg"
  },
  { 
    id: 20, 
    name: "Wolves", 
    country: "England", 
    league: "Premier League", 
    lat: 52.5903, 
    lng: -2.1304, 
    city: "Wolverhampton",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/fc/Wolverhampton_Wanderers.svg"
  },

  // La Liga
  { 
    id: 21, 
    name: "Real Madrid", 
    country: "Spain", 
    league: "La Liga", 
    lat: 40.4531, 
    lng: -3.6883, 
    city: "Madrid",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/56/Real_Madrid_CF.svg"
  },
  { 
    id: 22, 
    name: "Barcelona", 
    country: "Spain", 
    league: "La Liga", 
    lat: 41.3809, 
    lng: 2.1228, 
    city: "Barcelona",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/47/FC_Barcelona_%28crest%29.svg"
  },
  { 
    id: 23, 
    name: "Atlético Madrid", 
    country: "Spain", 
    league: "La Liga", 
    lat: 40.4368, 
    lng: -3.5995, 
    city: "Madrid",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/f4/Atletico_Madrid_2017_logo.svg"
  },
  { 
    id: 24, 
    name: "Sevilla", 
    country: "Spain", 
    league: "La Liga", 
    lat: 37.3821, 
    lng: -5.9707, 
    city: "Seville",
    crest: "https://upload.wikimedia.org/wikipedia/en/3/37/Sevilla_FC_logo.svg"
  },
  { 
    id: 25, 
    name: "Villarreal", 
    country: "Spain", 
    league: "La Liga", 
    lat: 39.9375, 
    lng: -0.1014, 
    city: "Villarreal",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/70/Villarreal_CF_logo.svg"
  },
  { 
    id: 26, 
    name: "Real Sociedad", 
    country: "Spain", 
    league: "La Liga", 
    lat: 43.3019, 
    lng: -1.9739, 
    city: "San Sebastián",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/f1/Real_Sociedad_logo.svg"
  },
  { 
    id: 27, 
    name: "Athletic Bilbao", 
    country: "Spain", 
    league: "La Liga", 
    lat: 43.2644, 
    lng: -2.9491, 
    city: "Bilbao",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/98/Club_Athletic_Bilbao_logo.svg"
  },
  { 
    id: 28, 
    name: "Real Betis", 
    country: "Spain", 
    league: "La Liga", 
    lat: 37.3844, 
    lng: -5.9707, 
    city: "Seville",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/13/Real_betis_logo.svg"
  },
  { 
    id: 29, 
    name: "Valencia", 
    country: "Spain", 
    league: "La Liga", 
    lat: 39.4747, 
    lng: -0.3584, 
    city: "Valencia",
    crest: "https://upload.wikimedia.org/wikipedia/en/c/ce/Valenciacf.svg"
  },
  { 
    id: 30, 
    name: "Getafe", 
    country: "Spain", 
    league: "La Liga", 
    lat: 40.3047, 
    lng: -3.7231, 
    city: "Getafe",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/6d/Getafe_CF_logo.svg"
  },
  { 
    id: 31, 
    name: "Osasuna", 
    country: "Spain", 
    league: "La Liga", 
    lat: 42.8181, 
    lng: -1.6432, 
    city: "Pamplona",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/82/CA_Osasuna_logo.svg"
  },
  { 
    id: 32, 
    name: "Rayo Vallecano", 
    country: "Spain", 
    league: "La Liga", 
    lat: 40.3906, 
    lng: -3.6564, 
    city: "Madrid",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/15/Rayo_vallecano_logo.svg"
  },
  { 
    id: 33, 
    name: "Celta Vigo", 
    country: "Spain", 
    league: "La Liga", 
    lat: 42.2118, 
    lng: -8.7311, 
    city: "Vigo",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/12/RC_Celta_de_Vigo_logo.svg"
  },
  { 
    id: 34, 
    name: "Mallorca", 
    country: "Spain", 
    league: "La Liga", 
    lat: 39.5856, 
    lng: 2.6506, 
    city: "Palma",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/RCD_Mallorca.svg"
  },
  { 
    id: 35, 
    name: "Girona", 
    country: "Spain", 
    league: "La Liga", 
    lat: 41.9794, 
    lng: 2.8214, 
    city: "Girona",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/62/Girona_FC_logo.svg"
  },
  { 
    id: 36, 
    name: "Elche", 
    country: "Spain", 
    league: "La Liga", 
    lat: 38.2622, 
    lng: -0.7011, 
    city: "Elche",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/Elche_CF_logo.svg"
  },
  { 
    id: 37, 
    name: "Espanyol", 
    country: "Spain", 
    league: "La Liga", 
    lat: 41.3809, 
    lng: 2.1228, 
    city: "Barcelona",
    crest: "https://upload.wikimedia.org/wikipedia/en/a/a7/RCD_Espanyol_logo.svg"
  },
  { 
    id: 38, 
    name: "Levante", 
    country: "Spain", 
    league: "La Liga", 
    lat: 39.4747, 
    lng: -0.3584, 
    city: "Valencia",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7b/Levante_UD_logo.svg"
  },
  { 
    id: 39, 
    name: "Real Oviedo", 
    country: "Spain", 
    league: "La Liga", 
    lat: 43.3603, 
    lng: -5.8448, 
    city: "Oviedo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/43/Real_Oviedo.svg"
  },
  { 
    id: 40, 
    name: "Alavés", 
    country: "Spain", 
    league: "La Liga", 
    lat: 42.8467, 
    lng: -2.6716, 
    city: "Vitoria-Gasteiz",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9f/Deportivo_Alaves_logo.svg"
  },

  // Bundesliga
  { 
    id: 41, 
    name: "Bayern Munich", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 48.2188, 
    lng: 11.6242, 
    city: "Munich",
    crest: "https://upload.wikimedia.org/wikipedia/commons/1/1b/FC_Bayern_M%C3%BCnchen_logo_%282017%29.svg"
  },
  { 
    id: 42, 
    name: "Bayer Leverkusen", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 51.0381, 
    lng: 7.0028, 
    city: "Leverkusen",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/59/Bayer_04_Leverkusen_logo.svg"
  },
  { 
    id: 44, 
    name: "RB Leipzig", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 51.3461, 
    lng: 12.3567, 
    city: "Leipzig",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/04/RB_Leipzig_2014_logo.svg"
  },
  { 
    id: 45, 
    name: "Borussia Dortmund", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 51.4926, 
    lng: 7.4518, 
    city: "Dortmund",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/67/Borussia_Dortmund_logo.svg"
  },
  { 
    id: 46, 
    name: "Stuttgart", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 48.7758, 
    lng: 9.1829, 
    city: "Stuttgart",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/eb/VfB_Stuttgart_1893_Logo.svg"
  },
  { 
    id: 47, 
    name: "Eintracht Frankfurt", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 50.0686, 
    lng: 8.6454, 
    city: "Frankfurt",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/04/Eintracht_Frankfurt_Logo.svg"
  },
  { 
    id: 48, 
    name: "Hoffenheim", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 49.2431, 
    lng: 8.8864, 
    city: "Sinsheim",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9e/TSG_1899_Hoffenheim_logo.svg"
  },
  { 
    id: 49, 
    name: "Freiburg", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 47.9990, 
    lng: 7.8421, 
    city: "Freiburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/SC_Freiburg_logo.svg"
  },
  { 
    id: 50, 
    name: "Heidenheim", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 48.6761, 
    lng: 10.1514, 
    city: "Heidenheim",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4a/1._FC_Heidenheim_1846_logo.svg"
  },
  { 
    id: 51, 
    name: "Wolfsburg", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 52.4308, 
    lng: 10.7972, 
    city: "Wolfsburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/f3/VfL_Wolfsburg.svg"
  },
  { 
    id: 52, 
    name: "Union Berlin", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 52.5200, 
    lng: 13.4050, 
    city: "Berlin",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/44/1._FC_Union_Berlin_Logo.svg"
  },
  { 
    id: 53, 
    name: "Augsburg", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 48.3705, 
    lng: 10.8978, 
    city: "Augsburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/6f/FC_Augsburg_Logo.svg"
  },
  { 
    id: 54, 
    name: "St Pauli", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 53.5511, 
    lng: 9.9937, 
    city: "Hamburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/6e/FC_St._Pauli_Logo.svg"
  },
  { 
    id: 55, 
    name: "Cologne", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 50.9375, 
    lng: 6.9603, 
    city: "Cologne",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/53/FC_Cologne_logo.svg"
  },
  { 
    id: 56, 
    name: "Mainz 05", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 50.0014, 
    lng: 8.2713, 
    city: "Mainz",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9e/1._FSV_Mainz_05_logo.svg"
  },
  { 
    id: 57, 
    name: "Hamburg", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 53.5511, 
    lng: 9.9937, 
    city: "Hamburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/66/Hamburger_SV_logo.svg"
  },
  { 
    id: 58, 
    name: "Hertha BSC", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 52.5200, 
    lng: 13.4050, 
    city: "Berlin",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/81/Hertha_BSC_Logo_2012.svg"
  },

  // Serie A
  { 
    id: 59, 
    name: "Atalanta", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.7389, 
    lng: 9.6778, 
    city: "Bergamo",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/66/Atalanta_BC.svg"
  },
  { 
    id: 60, 
    name: "Bologna", 
    country: "Italy", 
    league: "Serie A", 
    lat: 44.4949, 
    lng: 11.3426, 
    city: "Bologna",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/Bologna_FC_1909_logo.svg"
  },
  { 
    id: 61, 
    name: "Cagliari", 
    country: "Italy", 
    league: "Serie A", 
    lat: 39.2238, 
    lng: 9.1217, 
    city: "Cagliari",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/1e/Cagliari_Calcio_1920.svg"
  },
  { 
    id: 62, 
    name: "Como", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.8081, 
    lng: 9.0852, 
    city: "Como",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4d/Como_1907_logo.svg"
  },
  { 
    id: 63, 
    name: "Cremonese", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.1331, 
    lng: 10.0222, 
    city: "Cremona",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8c/US_Cremonese_logo.svg"
  },
  { 
    id: 64, 
    name: "Fiorentina", 
    country: "Italy", 
    league: "Serie A", 
    lat: 43.7696, 
    lng: 11.2558, 
    city: "Florence",
    crest: "https://upload.wikimedia.org/wikipedia/en/2/2a/ACF_Fiorentina.svg"
  },
  { 
    id: 65, 
    name: "Genoa", 
    country: "Italy", 
    league: "Serie A", 
    lat: 44.4056, 
    lng: 8.9463, 
    city: "Genoa",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/Genoa_CFC_logo.svg"
  },
  { 
    id: 66, 
    name: "Inter", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.4781, 
    lng: 9.1240, 
    city: "Milan",
    crest: "https://upload.wikimedia.org/wikipedia/commons/0/05/FC_Internazionale_Milano_2021.svg"
  },
  { 
    id: 67, 
    name: "Juventus", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.1096, 
    lng: 7.6412, 
    city: "Turin",
    crest: "https://upload.wikimedia.org/wikipedia/commons/1/15/Juventus_FC_2017_logo.svg"
  },
  { 
    id: 68, 
    name: "Lazio", 
    country: "Italy", 
    league: "Serie A", 
    lat: 41.9028, 
    lng: 12.4964, 
    city: "Rome",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/e1/SS_Lazio_badge.svg"
  },
  { 
    id: 69, 
    name: "Lecce", 
    country: "Italy", 
    league: "Serie A", 
    lat: 40.3512, 
    lng: 18.1750, 
    city: "Lecce",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8d/US_Lecce_logo.svg"
  },
  { 
    id: 70, 
    name: "Milan", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.4781, 
    lng: 9.1240, 
    city: "Milan",
    crest: "https://upload.wikimedia.org/wikipedia/commons/d/d0/Logo_of_AC_Milan.svg"
  },
  { 
    id: 71, 
    name: "Napoli", 
    country: "Italy", 
    league: "Serie A", 
    lat: 40.8518, 
    lng: 14.2681, 
    city: "Naples",
    crest: "https://upload.wikimedia.org/wikipedia/commons/2/2d/SSC_Neapel.svg"
  },
  { 
    id: 72, 
    name: "Parma", 
    country: "Italy", 
    league: "Serie A", 
    lat: 44.8015, 
    lng: 10.3279, 
    city: "Parma",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/Parma_Calcio_1913_logo.svg"
  },
  { 
    id: 73, 
    name: "Pisa", 
    country: "Italy", 
    league: "Serie A", 
    lat: 43.7228, 
    lng: 10.4017, 
    city: "Pisa",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8c/AC_Pisa_1909_logo.svg"
  },
  { 
    id: 74, 
    name: "Roma", 
    country: "Italy", 
    league: "Serie A", 
    lat: 41.9028, 
    lng: 12.4964, 
    city: "Rome",
    crest: "https://upload.wikimedia.org/wikipedia/en/f/f7/AS_Roma_logo_%282017%29.svg"
  },
  { 
    id: 75, 
    name: "Sassuolo", 
    country: "Italy", 
    league: "Serie A", 
    lat: 44.5456, 
    lng: 10.9256, 
    city: "Sassuolo",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/6d/US_Sassuolo_Calcio_logo.svg"
  },
  { 
    id: 76, 
    name: "Torino", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.1096, 
    lng: 7.6412, 
    city: "Turin",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8d/Torino_FC_Logo.svg"
  },
  { 
    id: 77, 
    name: "Udinese", 
    country: "Italy", 
    league: "Serie A", 
    lat: 46.0716, 
    lng: 13.2347, 
    city: "Udine",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/1e/Udinese_Calcio_logo.svg"
  },
  { 
    id: 78, 
    name: "Verona", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.4384, 
    lng: 10.9916, 
    city: "Verona",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/10/Hellas_Verona_FC_logo.svg"
  },

  // Ligue 1
  { 
    id: 79, 
    name: "Angers", 
    country: "France", 
    league: "Ligue 1", 
    lat: 47.4784, 
    lng: -0.5632, 
    city: "Angers",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/SCO_Angers_logo.svg"
  },
  { 
    id: 80, 
    name: "Auxerre", 
    country: "France", 
    league: "Ligue 1", 
    lat: 47.7984, 
    lng: 3.5678, 
    city: "Auxerre",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/AJ_Auxerre_logo.svg"
  },
  { 
    id: 81, 
    name: "Brest", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.3905, 
    lng: -4.4860, 
    city: "Brest",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9c/Stade_Brestois_29_logo.svg"
  },
  { 
    id: 82, 
    name: "Le Havre", 
    country: "France", 
    league: "Ligue 1", 
    lat: 49.4944, 
    lng: 0.1079, 
    city: "Le Havre",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/Le_Havre_AC_logo.svg"
  },
  { 
    id: 83, 
    name: "Lens", 
    country: "France", 
    league: "Ligue 1", 
    lat: 50.4292, 
    lng: 2.8310, 
    city: "Lens",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/RC_Lens_logo.svg"
  },
  { 
    id: 84, 
    name: "Lille", 
    country: "France", 
    league: "Ligue 1", 
    lat: 50.6292, 
    lng: 3.0573, 
    city: "Lille",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/LOSC_Lille_logo.svg"
  },
  { 
    id: 85, 
    name: "Lorient", 
    country: "France", 
    league: "Ligue 1", 
    lat: 47.7489, 
    lng: -3.3669, 
    city: "Lorient",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/FC_Lorient_logo.svg"
  },
  { 
    id: 86, 
    name: "Lyon", 
    country: "France", 
    league: "Ligue 1", 
    lat: 45.7640, 
    lng: 4.8357, 
    city: "Lyon",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/Olympique_Lyonnais_logo.svg"
  },
  { 
    id: 87, 
    name: "Marseille", 
    country: "France", 
    league: "Ligue 1", 
    lat: 43.2965, 
    lng: 5.3698, 
    city: "Marseille",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4e/Olympique_de_Marseille_logo.svg"
  },
  { 
    id: 88, 
    name: "Metz", 
    country: "France", 
    league: "Ligue 1", 
    lat: 49.1193, 
    lng: 6.1757, 
    city: "Metz",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/FC_Metz_logo.svg"
  },
  { 
    id: 89, 
    name: "Monaco", 
    country: "France", 
    league: "Ligue 1", 
    lat: 43.7384, 
    lng: 7.4246, 
    city: "Monaco",
    crest: "https://upload.wikimedia.org/wikipedia/en/2/2e/AS_Monaco_FC_logo.svg"
  },
  { 
    id: 90, 
    name: "Nantes", 
    country: "France", 
    league: "Ligue 1", 
    lat: 47.2184, 
    lng: -1.5536, 
    city: "Nantes",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/FC_Nantes_logo.svg"
  },
  { 
    id: 91, 
    name: "Nice", 
    country: "France", 
    league: "Ligue 1", 
    lat: 43.7102, 
    lng: 7.2620, 
    city: "Nice",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/OGC_Nice_logo.svg"
  },
  { 
    id: 92, 
    name: "Paris FC", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.8566, 
    lng: 2.3522, 
    city: "Paris",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/Paris_FC_logo.svg"
  },
  { 
    id: 93, 
    name: "Paris Saint-Germain", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.8566, 
    lng: 2.3522, 
    city: "Paris",
    crest: "https://upload.wikimedia.org/wikipedia/en/a/a7/Paris_Saint-Germain_F.C._logo.svg"
  },
  { 
    id: 94, 
    name: "Rennes", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.1173, 
    lng: -1.6778, 
    city: "Rennes",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/Stade_Rennais_FC_logo.svg"
  },
  { 
    id: 95, 
    name: "Strasbourg", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.5734, 
    lng: 7.7521, 
    city: "Strasbourg",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/RC_Strasbourg_logo.svg"
  },
  { 
    id: 96, 
    name: "Toulouse", 
    country: "France", 
    league: "Ligue 1", 
    lat: 43.6047, 
    lng: 1.4442, 
    city: "Toulouse",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/Toulouse_FC_logo.svg"
  },

  // Other clubs
  { 
    id: 97, 
    name: "Sporting CP", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 38.7223, 
    lng: -9.1393, 
    city: "Lisbon",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/5e/Sporting_Clube_de_Portugal_logo.svg"
  },
  { 
    id: 98, 
    name: "Feyenoord", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51.9244, 
    lng: 4.4777, 
    city: "Rotterdam",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/64/Feyenoord_logo.svg"
  },
  { 
    id: 99, 
    name: "PSV Eindhoven", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51.4416, 
    lng: 5.4697, 
    city: "Eindhoven",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/03/PSV_Eindhoven_logo.svg"
  },
  { 
    id: 100, 
    name: "Ajax", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 52.3141, 
    lng: 4.9406, 
    city: "Amsterdam",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/79/Ajax_Amsterdam_%28logo%29.svg"
  },
  { 
    id: 101, 
    name: "Galatasaray", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/commons/2/20/Galatasaray_Sports_Club_Logo.svg"
  },
  { 
    id: 102, 
    name: "Al-Nassr", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 24.7136, 
    lng: 46.6753, 
    city: "Riyadh",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9b/Al-Nassr_FC_logo.svg"
  },
  { 
    id: 103, 
    name: "Vancouver Whitecaps", 
    country: "Canada", 
    league: "MLS", 
    lat: 49.2827, 
    lng: -123.1207, 
    city: "Vancouver",
    crest: "https://upload.wikimedia.org/wikipedia/en/c/c4/Vancouver_Whitecaps_FC_logo.svg"
  },
  { 
    id: 104, 
    name: "Sunderland", 
    country: "England", 
    league: "Championship", 
    lat: 54.9069, 
    lng: -1.3838, 
    city: "Sunderland",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/77/Sunderland_AFC_logo.svg"
  },
  { 
    id: 105, 
    name: "AZ Alkmaar", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 52.6316, 
    lng: 4.7489, 
    city: "Alkmaar",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/0f/AZ_Alkmaar_logo.svg"
  },
  { 
    id: 106, 
    name: "River Plate", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -34.5456, 
    lng: -58.4494, 
    city: "Buenos Aires",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/1a/CA_River_Plate_%28logo%29.svg"
  },
  { 
    id: 107, 
    name: "Atlanta United", 
    country: "United States", 
    league: "MLS", 
    lat: 33.7490, 
    lng: -84.3880, 
    city: "Atlanta",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7c/Atlanta_United_FC_logo.svg"
  },
  { 
    id: 108, 
    name: "Flamengo", 
    country: "Brazil", 
    league: "Série A", 
    lat: -22.9068, 
    lng: -43.1729, 
    city: "Rio de Janeiro",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9c/CR_Flamengo_logo.svg"
  },
  { 
    id: 109, 
    name: "Celtic", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 55.8642, 
    lng: -4.2518, 
    city: "Glasgow",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/12/Celtic_FC_logo.svg"
  },
  { 
    id: 110, 
    name: "Cruzeiro", 
    country: "Brazil", 
    league: "Série A", 
    lat: -19.9167, 
    lng: -43.9345, 
    city: "Belo Horizonte",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Cruzeiro_Esporte_Clube_logo.svg"
  },
  { 
    id: 111, 
    name: "Coventry City", 
    country: "England", 
    league: "Championship", 
    lat: 52.4068, 
    lng: -1.5197, 
    city: "Coventry",
    crest: "https://upload.wikimedia.org/wikipedia/en/5/5c/Coventry_City_FC_logo.svg"
  },
  { 
    id: 112, 
    name: "Vasco da Gama", 
    country: "Brazil", 
    league: "Série A", 
    lat: -22.9068, 
    lng: -43.1729, 
    city: "Rio de Janeiro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CR_Vasco_da_Gama_logo.svg"
  },
  { 
    id: 113, 
    name: "Club Brugge", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.2093, 
    lng: 3.2247, 
    city: "Bruges",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/0f/Club_Brugge_KV_logo.svg"
  },
  { 
    id: 114, 
    name: "Hellas Verona", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.4384, 
    lng: 10.9916, 
    city: "Verona",
    crest: "https://upload.wikimedia.org/wikipedia/en/1/10/Hellas_Verona_FC_logo.svg"
  },
  { 
    id: 115, 
    name: "Olympiacos", 
    country: "Greece", 
    league: "Super League", 
    lat: 37.9755, 
    lng: 23.7348, 
    city: "Piraeus",
    crest: "https://upload.wikimedia.org/wikipedia/en/7/7b/Olympiacos_FC_logo.svg"
  },
  { 
    id: 116, 
    name: "Millwall", 
    country: "England", 
    league: "Championship", 
    lat: 51.4859, 
    lng: -0.0504, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/90/Millwall_FC_logo.svg"
  },
  { 
    id: 117, 
    name: "Karlsruher SC", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 49.0069, 
    lng: 8.4037, 
    city: "Karlsruhe",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Karlsruher_SC_logo.svg"
  },
  { 
    id: 118, 
    name: "Stuttgart", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 48.7758, 
    lng: 9.1829, 
    city: "Stuttgart",
    crest: "https://upload.wikimedia.org/wikipedia/en/e/eb/VfB_Stuttgart_1893_Logo.svg"
  },
  { 
    id: 119, 
    name: "Ipswich Town", 
    country: "England", 
    league: "Championship", 
    lat: 52.0594, 
    lng: 1.1556, 
    city: "Ipswich",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/43/Ipswich_Town_FC_logo.svg"
  },
  { 
    id: 120, 
    name: "Rangers", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 55.8642, 
    lng: -4.2518, 
    city: "Glasgow",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4a/Rangers_FC_logo.svg"
  },
  { 
    id: 121, 
    name: "Botafogo", 
    country: "Brazil", 
    league: "Série A", 
    lat: -22.9068, 
    lng: -43.1729, 
    city: "Rio de Janeiro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Botafogo_FR_logo.svg"
  },
  { 
    id: 122, 
    name: "Birmingham City", 
    country: "England", 
    league: "Championship", 
    lat: 52.4754, 
    lng: -1.8683, 
    city: "Birmingham",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/68/Birmingham_City_FC_logo.svg"
  },
  { 
    id: 124, 
    name: "Palmeiras", 
    country: "Brazil", 
    league: "Série A", 
    lat: -23.5505, 
    lng: -46.6333, 
    city: "São Paulo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SE_Palmeiras_logo.svg"
  },
  { 
    id: 125, 
    name: "Independiente del Valle", 
    country: "Ecuador", 
    league: "Serie A", 
    lat: -0.1807, 
    lng: -78.4678, 
    city: "Sangolquí",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Independiente_del_Valle_logo.svg"
  },
  { 
    id: 126, 
    name: "RC Strasbourg", 
    country: "France", 
    league: "Ligue 1", 
    lat: 48.5734, 
    lng: 7.7521, 
    city: "Strasbourg",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/RC_Strasbourg_logo.svg"
  },
  { 
    id: 127, 
    name: "Al Qadsiah", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 26.4207, 
    lng: 50.0888, 
    city: "Khobar",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al_Qadsiah_FC_logo.svg"
  },
  { 
    id: 128, 
    name: "Châteauroux", 
    country: "France", 
    league: "Ligue 2", 
    lat: 46.8103, 
    lng: 1.6911, 
    city: "Châteauroux",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/La_Berrichonne_de_Châteauroux_logo.svg"
  },
  { 
    id: 129, 
    name: "Braga", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 41.5518, 
    lng: -8.4229, 
    city: "Braga",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Braga_logo.svg"
  },
  { 
    id: 130, 
    name: "Norwich City", 
    country: "England", 
    league: "Championship", 
    lat: 52.6309, 
    lng: 1.2974, 
    city: "Norwich",
    crest: "https://upload.wikimedia.org/wikipedia/en/8/8e/Norwich_City_FC_logo.svg"
  },
  { 
    id: 131, 
    name: "Mirandés", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 42.6868, 
    lng: -2.9491, 
    city: "Miranda de Ebro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Mirandés_logo.svg"
  },
  { 
    id: 132, 
    name: "Mirandes", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 42.6868, 
    lng: -2.9491, 
    city: "Miranda de Ebro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Mirandés_logo.svg"
  },
  { 
    id: 133, 
    name: "PAOK", 
    country: "Greece", 
    league: "Super League", 
    lat: 40.6401, 
    lng: 22.9444, 
    city: "Thessaloniki",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/PAOK_FC_logo.svg"
  },
  { 
    id: 134, 
    name: "Fortaleza", 
    country: "Brazil", 
    league: "Série A", 
    lat: -3.7319, 
    lng: -38.5267, 
    city: "Fortaleza",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fortaleza_EC_logo.svg"
  },
  { 
    id: 135, 
    name: "Daejeon Hana Citizen", 
    country: "South Korea", 
    league: "K League 1", 
    lat: 36.3504, 
    lng: 127.3845, 
    city: "Daejeon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Daejeon_Hana_Citizen_FC_logo.svg"
  },
  { 
    id: 136, 
    name: "Rapid Wien", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 48.2082, 
    lng: 16.3738, 
    city: "Vienna",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SK_Rapid_Wien_logo.svg"
  },
  { 
    id: 137, 
    name: "Le Mans", 
    country: "France", 
    league: "Ligue 2", 
    lat: 48.0061, 
    lng: 0.1996, 
    city: "Le Mans",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Le_Mans_FC_logo.svg"
  },
  { 
    id: 138, 
    name: "IFK Norrköping", 
    country: "Sweden", 
    league: "Allsvenskan", 
    lat: 58.5877, 
    lng: 16.1924, 
    city: "Norrköping",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/IFK_Norrköping_logo.svg"
  },
  { 
    id: 140, 
    name: "LASK", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 48.3069, 
    lng: 14.2858, 
    city: "Linz",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/LASK_logo.svg"
  },
  { 
    id: 141, 
    name: "Free agent", 
    country: "Various", 
    league: "Free Agent", 
    lat: 0, 
    lng: 0, 
    city: "Various",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Free_agent_logo.svg"
  },
  { 
    id: 142, 
    name: "Kasımpaşa", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kasımpaşa_SK_logo.svg"
  },
  { 
    id: 143, 
    name: "TSG Hoffenheim", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 49.2431, 
    lng: 8.8864, 
    city: "Sinsheim",
    crest: "https://upload.wikimedia.org/wikipedia/en/9/9e/TSG_1899_Hoffenheim_logo.svg"
  },
  { 
    id: 144, 
    name: "FC Copenhagen", 
    country: "Denmark", 
    league: "Superliga", 
    lat: 55.6761, 
    lng: 12.5683, 
    city: "Copenhagen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Copenhagen_logo.svg"
  },
  { 
    id: 145, 
    name: "Fenerbahçe", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fenerbahçe_SK_logo.svg"
  },
  { 
    id: 146, 
    name: "Motherwell", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 55.7922, 
    lng: -3.9889, 
    city: "Motherwell",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Motherwell_FC_logo.svg"
  },
  { 
    id: 147, 
    name: "Beşiktaş", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Beşiktaş_JK_logo.svg"
  },
  { 
    id: 148, 
    name: "Como 1907", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.8081, 
    lng: 9.0852, 
    city: "Como",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4d/Como_1907_logo.svg"
  },
  { 
    id: 150, 
    name: "Cercle Brugge", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.2093, 
    lng: 3.2247, 
    city: "Bruges",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Cercle_Brugge_KSV_logo.svg"
  },
  { 
    id: 151, 
    name: "Tigres UANL", 
    country: "Mexico", 
    league: "Liga MX", 
    lat: 25.6866, 
    lng: -100.3161, 
    city: "San Nicolás de los Garza",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Tigres_UANL_logo.svg"
  },
  { 
    id: 152, 
    name: "Girona", 
    country: "Spain", 
    league: "La Liga", 
    lat: 41.9794, 
    lng: 2.8214, 
    city: "Girona",
    crest: "https://upload.wikimedia.org/wikipedia/en/6/62/Girona_FC_logo.svg"
  }
,

  // Additional clubs from transfers
  { 
    id: 153, 
    name: "Released", 
    country: "Various", 
    league: "Various", 
    lat: 0, 
    lng: 0, 
    city: "Various",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Default_club_crest.svg"
  },
  { 
    id: 154, 
    name: "Kasimpasa", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/tr/8/8a/Kasimpasa_SK_logo.png"
  },
  { 
    id: 155, 
    name: "Malmö", 
    country: "Sweden", 
    league: "Allsvenskan", 
    lat: 55.605, 
    lng: 13.0038, 
    city: "Malmö",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4a/Malm%C3%B6_FF_logo.svg"
  },
  { 
    id: 156, 
    name: "Zilina", 
    country: "Slovakia", 
    league: "Fortuna Liga", 
    lat: 49.2231, 
    lng: 18.7394, 
    city: "Žilina",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/M%C5%A0K_%C5%BDilina_logo.svg"
  },
  { 
    id: 157, 
    name: "Brøndby", 
    country: "Denmark", 
    league: "Superligaen", 
    lat: 55.6508, 
    lng: 12.4203, 
    city: "Brøndby",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Br%C3%B8ndby_IF_logo.svg"
  },
  { 
    id: 158, 
    name: "Retired", 
    country: "Various", 
    league: "Various", 
    lat: 0, 
    lng: 0, 
    city: "Various",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Default_club_crest.svg"
  },
  { 
    id: 159, 
    name: "Werder Bremen", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 53.1077, 
    lng: 8.8455, 
    city: "Bremen",
    crest: "https://upload.wikimedia.org/wikipedia/en/0/0e/SV_Werder_Bremen_logo.svg"
  },
  { 
    id: 160, 
    name: "Nuremberg", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 49.4256, 
    lng: 11.1242, 
    city: "Nuremberg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/1._FC_N%C3%BCrnberg_logo.svg"
  },
  { 
    id: 161, 
    name: "Montpellier", 
    country: "France", 
    league: "Ligue 1", 
    lat: 43.611, 
    lng: 3.8767, 
    city: "Montpellier",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Montpellier_HSC_logo.svg"
  },
  { 
    id: 162, 
    name: "Hajduk Split", 
    country: "Croatia", 
    league: "Hrvatska nogometna liga", 
    lat: 43.5081, 
    lng: 16.4402, 
    city: "Split",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/HNK_Hajduk_Split_logo.svg"
  },
  { 
    id: 163, 
    name: "Northampton", 
    country: "England", 
    league: "League One", 
    lat: 52.2405, 
    lng: -0.9027, 
    city: "Northampton",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Northampton_Town_FC_logo.svg"
  },
  { 
    id: 164, 
    name: "Leicester City", 
    country: "England", 
    league: "Championship", 
    lat: 52.62, 
    lng: -1.1422, 
    city: "Leicester",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Leicester_City_FC_logo.svg"
  },
  { 
    id: 165, 
    name: "Troyes", 
    country: "France", 
    league: "Ligue 2", 
    lat: 48.2973, 
    lng: 4.0744, 
    city: "Troyes",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/ES_Troyes_AC_logo.svg"
  },
  { 
    id: 166, 
    name: "Real Valladolid", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 41.652, 
    lng: -4.7245, 
    city: "Valladolid",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Real_Valladolid_logo.svg"
  },
  { 
    id: 167, 
    name: "OH Leuven", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8798, 
    lng: 4.7005, 
    city: "Leuven",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Oud-Heverlee_Leuven_logo.svg"
  },
  { 
    id: 168, 
    name: "Daejon Hana Citizen", 
    country: "South Korea", 
    league: "K League 2", 
    lat: 36.3504, 
    lng: 127.3845, 
    city: "Daejeon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Daejeon_Hana_Citizen_FC_logo.svg"
  },
  { 
    id: 169, 
    name: "Al-Arabi", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.2854, 
    lng: 51.531, 
    city: "Doha",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Arabi_SC_logo.svg"
  },
  { 
    id: 170, 
    name: "Elversberg", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 49.3, 
    lng: 7.1333, 
    city: "Spiesen-Elversberg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Elversberg_logo.svg"
  },
  { 
    id: 171, 
    name: "Holstein Kiel", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 54.3233, 
    lng: 10.1228, 
    city: "Kiel",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Holstein_Kiel_logo.svg"
  },
  { 
    id: 172, 
    name: "Krasnodar", 
    country: "Russia", 
    league: "Russian Premier League", 
    lat: 45.0448, 
    lng: 38.976, 
    city: "Krasnodar",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Krasnodar_logo.svg"
  },
  { 
    id: 173, 
    name: "Red Bull Salzburg", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 47.8095, 
    lng: 13.055, 
    city: "Salzburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Red_Bull_Salzburg_logo.svg"
  },
  { 
    id: 174, 
    name: "Bochum", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 51.4818, 
    lng: 7.2162, 
    city: "Bochum",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/VfL_Bochum_logo.svg"
  },
  { 
    id: 175, 
    name: "Leganés", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 40.3272, 
    lng: -3.7639, 
    city: "Leganés",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Legan%C3%A9s_logo.svg"
  },
  { 
    id: 176, 
    name: "Fortuna Düsseldorf", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 51.2277, 
    lng: 6.7735, 
    city: "Düsseldorf",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fortuna_D%C3%BCsseldorf_logo.svg"
  },
  { 
    id: 177, 
    name: "Southampton", 
    country: "England", 
    league: "Championship", 
    lat: 50.9097, 
    lng: -1.4044, 
    city: "Southampton",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Southampton_FC_logo.svg"
  },
  { 
    id: 178, 
    name: "Paderborn", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 51.7189, 
    lng: 8.7574, 
    city: "Paderborn",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Paderborn_07_logo.svg"
  },
  { 
    id: 179, 
    name: "Damac", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 18.2465, 
    lng: 42.5056, 
    city: "Khamis Mushait",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Damac_FC_logo.svg"
  },
  { 
    id: 180, 
    name: "Saint-Etienne", 
    country: "France", 
    league: "Ligue 2", 
    lat: 45.4397, 
    lng: 4.3872, 
    city: "Saint-Étienne",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AS_Saint-%C3%89tienne_logo.svg"
  },
  { 
    id: 181, 
    name: "Grêmio", 
    country: "Brazil", 
    league: "Série A", 
    lat: -30.0346, 
    lng: -51.2177, 
    city: "Porto Alegre",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Gr%C3%AAmio_Foot-Ball_Porto_Alegrense_logo.svg"
  },
  { 
    id: 182, 
    name: "Dinamo Zagreb", 
    country: "Croatia", 
    league: "Hrvatska nogometna liga", 
    lat: 45.815, 
    lng: 15.9819, 
    city: "Zagreb",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/GNK_Dinamo_Zagreb_logo.svg"
  },
  { 
    id: 183, 
    name: "Málaga", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 36.7213, 
    lng: -4.4214, 
    city: "Málaga",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/M%C3%A1laga_CF_logo.svg"
  },
  { 
    id: 184, 
    name: "Red Star Belgrade", 
    country: "Serbia", 
    league: "Serbian SuperLiga", 
    lat: 44.7866, 
    lng: 20.4489, 
    city: "Belgrade",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Red_Star_Belgrade_logo.svg"
  },
  { 
    id: 185, 
    name: "Sandhausen", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 49.3147, 
    lng: 8.6586, 
    city: "Sandhausen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Sandhausen_logo.svg"
  },
  { 
    id: 186, 
    name: "Sint-Truiden", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8153, 
    lng: 5.1864, 
    city: "Sint-Truiden",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Sint-Truidense_VV_logo.svg"
  },
  { 
    id: 187, 
    name: "Austria Klagenfurt", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 46.6247, 
    lng: 14.3053, 
    city: "Klagenfurt",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SK_Austria_Klagenfurt_logo.svg"
  },
  { 
    id: 188, 
    name: "Puskás Akadémia", 
    country: "Hungary", 
    league: "NB I", 
    lat: 47.1625, 
    lng: 18.3931, 
    city: "Felcsút",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Pusk%C3%A1s_Akad%C3%A9mia_FC_logo.svg"
  },
  { 
    id: 189, 
    name: "Vélez Sarsfield", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -34.635, 
    lng: -58.5208, 
    city: "Buenos Aires",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_V%C3%A9lez_Sarsfield_logo.svg"
  },
  { 
    id: 190, 
    name: "Borussia Mönchengladbach", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 51.1805, 
    lng: 6.4428, 
    city: "Mönchengladbach",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Borussia_M%C3%B6nchengladbach_logo.svg"
  },
  { 
    id: 191, 
    name: "Darmstadt", 
    country: "Germany", 
    league: "Bundesliga", 
    lat: 49.8728, 
    lng: 8.6512, 
    city: "Darmstadt",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Darmstadt_98_logo.svg"
  },
  { 
    id: 192, 
    name: "SSV Ulm", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 48.4011, 
    lng: 9.9878, 
    city: "Ulm",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SSV_Ulm_1846_logo.svg"
  },
  { 
    id: 193, 
    name: "QPR", 
    country: "England", 
    league: "Championship", 
    lat: 51.5094, 
    lng: -0.2322, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Queens_Park_Rangers_FC_logo.svg"
  },
  { 
    id: 194, 
    name: "Reims", 
    country: "France", 
    league: "Ligue 1", 
    lat: 49.2583, 
    lng: 4.0317, 
    city: "Reims",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Stade_de_Reims_logo.svg"
  },
  { 
    id: 195, 
    name: "Valenciennes", 
    country: "France", 
    league: "Ligue 2", 
    lat: 50.3592, 
    lng: 3.525, 
    city: "Valenciennes",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Valenciennes_FC_logo.svg"
  },
  { 
    id: 196, 
    name: "Stevenage", 
    country: "England", 
    league: "League One", 
    lat: 51.9019, 
    lng: -0.2025, 
    city: "Stevenage",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Stevenage_FC_logo.svg"
  },
  { 
    id: 197, 
    name: "Port Vale", 
    country: "England", 
    league: "League One", 
    lat: 53.0486, 
    lng: -2.1925, 
    city: "Stoke-on-Trent",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Port_Vale_FC_logo.svg"
  },
  { 
    id: 198, 
    name: "Kaiserslautern", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 49.4447, 
    lng: 7.7689, 
    city: "Kaiserslautern",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/1._FC_Kaiserslautern_logo.svg"
  },
  { 
    id: 199, 
    name: "Venezia", 
    country: "Italy", 
    league: "Serie B", 
    lat: 45.4408, 
    lng: 12.3155, 
    city: "Venice",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Venezia_FC_logo.svg"
  },
  { 
    id: 200, 
    name: "Granada", 
    country: "Spain", 
    league: "La Liga", 
    lat: 37.1773, 
    lng: -3.5986, 
    city: "Granada",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Granada_CF_logo.svg"
  },
  { 
    id: 201, 
    name: "KAA Gent", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.0543, 
    lng: 3.7174, 
    city: "Ghent",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/KAA_Gent_logo.svg"
  },
  { 
    id: 202, 
    name: "Swindon Town", 
    country: "England", 
    league: "League Two", 
    lat: 51.5559, 
    lng: -1.7797, 
    city: "Swindon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Swindon_Town_FC_logo.svg"
  }
,

  // Additional clubs from transfers (Batch 2)
  { 
    id: 203, 
    name: "Basel", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 47.5596, 
    lng: 7.5886, 
    city: "Basel",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Basel_logo.svg"
  },
  { 
    id: 204, 
    name: "Al-Duhail", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.2854, 
    lng: 51.531, 
    city: "Doha",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Duhail_SC_logo.svg"
  },
  { 
    id: 205, 
    name: "Benfica", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 38.7223, 
    lng: -9.1393, 
    city: "Lisbon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SL_Benfica_logo.svg"
  },
  { 
    id: 206, 
    name: "Melbourne Victory", 
    country: "Australia", 
    league: "A-League", 
    lat: -37.8136, 
    lng: 144.9631, 
    city: "Melbourne",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Melbourne_Victory_FC_logo.svg"
  },
  { 
    id: 207, 
    name: "Peterborough", 
    country: "England", 
    league: "League One", 
    lat: 52.5695, 
    lng: -0.2405, 
    city: "Peterborough",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Peterborough_United_FC_logo.svg"
  },
  { 
    id: 208, 
    name: "Empoli", 
    country: "Italy", 
    league: "Serie A", 
    lat: 43.7228, 
    lng: 10.4017, 
    city: "Empoli",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Empoli_FC_logo.svg"
  },
  { 
    id: 209, 
    name: "FC Utrecht", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 52.0907, 
    lng: 5.1214, 
    city: "Utrecht",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Utrecht_logo.svg"
  },
  { 
    id: 210, 
    name: "Koper", 
    country: "Slovenia", 
    league: "PrvaLiga", 
    lat: 45.5481, 
    lng: 13.7301, 
    city: "Koper",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Koper_logo.svg"
  },
  { 
    id: 211, 
    name: "Huddersfield", 
    country: "England", 
    league: "Championship", 
    lat: 53.6458, 
    lng: -1.785, 
    city: "Huddersfield",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Huddersfield_Town_AFC_logo.svg"
  },
  { 
    id: 212, 
    name: "RWDM Brussels", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8503, 
    lng: 4.3517, 
    city: "Brussels",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RWDM_logo.svg"
  },
  { 
    id: 213, 
    name: "Monza", 
    country: "Italy", 
    league: "Serie A", 
    lat: 45.5845, 
    lng: 9.2744, 
    city: "Monza",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Monza_logo.svg"
  },
  { 
    id: 214, 
    name: "Porto", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 41.1619, 
    lng: -8.5839, 
    city: "Porto",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Porto_logo.svg"
  },
  { 
    id: 215, 
    name: "Boca Juniors", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -34.635, 
    lng: -58.3651, 
    city: "Buenos Aires",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_Boca_Juniors_logo.svg"
  },
  { 
    id: 216, 
    name: "Toluca", 
    country: "Mexico", 
    league: "Liga MX", 
    lat: 19.292, 
    lng: -99.6572, 
    city: "Toluca",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Deportivo_Toluca_FC_logo.svg"
  },
  { 
    id: 217, 
    name: "Las Palmas", 
    country: "Spain", 
    league: "La Liga", 
    lat: 28.1248, 
    lng: -15.43, 
    city: "Las Palmas",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/UD_Las_Palmas_logo.svg"
  },
  { 
    id: 218, 
    name: "Caen", 
    country: "France", 
    league: "Ligue 2", 
    lat: 49.1829, 
    lng: -0.3707, 
    city: "Caen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SM_Caen_logo.svg"
  },
  { 
    id: 219, 
    name: "Al-Shamal", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.2854, 
    lng: 51.531, 
    city: "Doha",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Shamal_SC_logo.svg"
  },
  { 
    id: 220, 
    name: "Bastia", 
    country: "France", 
    league: "Ligue 2", 
    lat: 42.6977, 
    lng: 9.45, 
    city: "Bastia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Bastia_logo.svg"
  },
  { 
    id: 221, 
    name: "Córdoba", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 37.8882, 
    lng: -4.7794, 
    city: "Córdoba",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/C%C3%B3rdoba_CF_logo.svg"
  },
  { 
    id: 222, 
    name: "Rosenborg", 
    country: "Norway", 
    league: "Eliteserien", 
    lat: 63.4305, 
    lng: 10.3951, 
    city: "Trondheim",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Rosenborg_BK_logo.svg"
  },
  { 
    id: 223, 
    name: "Blau-Weiss Linz", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 48.3069, 
    lng: 14.2858, 
    city: "Linz",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Blau-Wei%C3%9F_Linz_logo.svg"
  },
  { 
    id: 224, 
    name: "Sion", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 46.2276, 
    lng: 7.3606, 
    city: "Sion",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Sion_logo.svg"
  },
  { 
    id: 225, 
    name: "Watford", 
    country: "England", 
    league: "Championship", 
    lat: 51.6498, 
    lng: -0.4016, 
    city: "Watford",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Watford_FC_logo.svg"
  },
  { 
    id: 226, 
    name: "Sanliurfaspor", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 37.1591, 
    lng: 38.7969, 
    city: "Şanlıurfa",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/%C5%9Eanl%C4%B1urfaspor_logo.svg"
  },
  { 
    id: 227, 
    name: "Westerlo", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.0853, 
    lng: 4.9156, 
    city: "Westerlo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/KVC_Westerlo_logo.svg"
  },
  { 
    id: 228, 
    name: "Castellón", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 39.9864, 
    lng: -0.0514, 
    city: "Castellón",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Castell%C3%B3n_logo.svg"
  },
  { 
    id: 229, 
    name: "Athletic Club", 
    country: "Spain", 
    league: "La Liga", 
    lat: 43.2627, 
    lng: -2.9253, 
    city: "Bilbao",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Athletic_Club_Bilbao_logo.svg"
  },
  { 
    id: 230, 
    name: "Preston", 
    country: "England", 
    league: "Championship", 
    lat: 53.7729, 
    lng: -2.7049, 
    city: "Preston",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Preston_North_End_FC_logo.svg"
  },
  { 
    id: 231, 
    name: "Bolton", 
    country: "England", 
    league: "League One", 
    lat: 53.58, 
    lng: -2.535, 
    city: "Bolton",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Bolton_Wanderers_FC_logo.svg"
  },
  { 
    id: 232, 
    name: "Eibar", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 43.1844, 
    lng: -2.4731, 
    city: "Eibar",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SD_Eibar_logo.svg"
  },
  { 
    id: 233, 
    name: "Colchester", 
    country: "England", 
    league: "League Two", 
    lat: 51.8959, 
    lng: 0.9034, 
    city: "Colchester",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Colchester_United_FC_logo.svg"
  },
  { 
    id: 234, 
    name: "Greuther Fürth", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 49.4778, 
    lng: 10.9889, 
    city: "Fürth",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SpVgg_Greuther_F%C3%BCrth_logo.svg"
  },
  { 
    id: 235, 
    name: "Arminia Bielefeld", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 52.0302, 
    lng: 8.5325, 
    city: "Bielefeld",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Arminia_Bielefeld_logo.svg"
  },
  { 
    id: 236, 
    name: "Hull City", 
    country: "England", 
    league: "Championship", 
    lat: 53.7446, 
    lng: -0.3355, 
    city: "Hull",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Hull_City_AFC_logo.svg"
  },
  { 
    id: 237, 
    name: "Sturm Graz", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 47.0707, 
    lng: 15.4395, 
    city: "Graz",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SK_Sturm_Graz_logo.svg"
  },
  { 
    id: 238, 
    name: "Nordsjælland", 
    country: "Denmark", 
    league: "Superligaen", 
    lat: 55.9231, 
    lng: 12.3108, 
    city: "Farum",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Nordsj%C3%A6lland_logo.svg"
  },
  { 
    id: 239, 
    name: "Mansfield Town", 
    country: "England", 
    league: "League Two", 
    lat: 53.1381, 
    lng: -1.2003, 
    city: "Mansfield",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Mansfield_Town_FC_logo.svg"
  },
  { 
    id: 240, 
    name: "Häcken", 
    country: "Sweden", 
    league: "Allsvenskan", 
    lat: 57.7089, 
    lng: 11.9746, 
    city: "Gothenburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/BK_H%C3%A4cken_logo.svg"
  },
  { 
    id: 241, 
    name: "Al-Ain", 
    country: "UAE", 
    league: "UAE Pro League", 
    lat: 24.2075, 
    lng: 55.7447, 
    city: "Al Ain",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al_Ain_FC_logo.svg"
  },
  { 
    id: 242, 
    name: "1860 Munich", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 48.1351, 
    lng: 11.582, 
    city: "Munich",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/TSV_1860_Munich_logo.svg"
  },
  { 
    id: 243, 
    name: "West Bromwich Albion", 
    country: "England", 
    league: "Championship", 
    lat: 52.509, 
    lng: -1.9639, 
    city: "West Bromwich",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/West_Bromwich_Albion_FC_logo.svg"
  },
  { 
    id: 244, 
    name: "RW Essen", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 51.4556, 
    lng: 7.0116, 
    city: "Essen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Rot-Weiss_Essen_logo.svg"
  },
  { 
    id: 245, 
    name: "Leyton Orient", 
    country: "England", 
    league: "League One", 
    lat: 51.5589, 
    lng: -0.0125, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Leyton_Orient_FC_logo.svg"
  },
  { 
    id: 246, 
    name: "Doncaster", 
    country: "England", 
    league: "League Two", 
    lat: 53.5228, 
    lng: -1.1314, 
    city: "Doncaster",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Doncaster_Rovers_FC_logo.svg"
  },
  { 
    id: 247, 
    name: "St Gallen", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 47.4245, 
    lng: 9.3767, 
    city: "St. Gallen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_St._Gallen_logo.svg"
  },
  { 
    id: 248, 
    name: "Rodez", 
    country: "France", 
    league: "Ligue 2", 
    lat: 44.3506, 
    lng: 2.5731, 
    city: "Rodez",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Rodez_AF_logo.svg"
  },
  { 
    id: 249, 
    name: "Puskas Akademia", 
    country: "Hungary", 
    league: "NB I", 
    lat: 47.1625, 
    lng: 18.3931, 
    city: "Felcsút",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Pusk%C3%A1s_Akad%C3%A9mia_FC_logo.svg"
  },
  { 
    id: 250, 
    name: "Debrecen", 
    country: "Hungary", 
    league: "NB I", 
    lat: 47.5316, 
    lng: 21.6273, 
    city: "Debrecen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/DVSC_Debrecen_logo.svg"
  },
  { 
    id: 251, 
    name: "Spezia", 
    country: "Italy", 
    league: "Serie B", 
    lat: 44.1025, 
    lng: 9.8242, 
    city: "La Spezia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Spezia_Calcio_logo.svg"
  },
  { 
    id: 252, 
    name: "Salamanca", 
    country: "Spain", 
    league: "Segunda División RFEF", 
    lat: 40.9701, 
    lng: -5.6635, 
    city: "Salamanca",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/UD_Salamanca_logo.svg"
  }
,

  // Additional clubs from transfers (Batch 3)
  { 
    id: 253, 
    name: "Legia Warsaw", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 52.2297, 
    lng: 21.0122, 
    city: "Warsaw",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Legia_Warsaw_logo.svg"
  },
  { 
    id: 254, 
    name: "Hércules", 
    country: "Spain", 
    league: "Segunda División RFEF", 
    lat: 38.3452, 
    lng: -0.481, 
    city: "Alicante",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/H%C3%A9rcules_CF_logo.svg"
  },
  { 
    id: 255, 
    name: "Crawley Town", 
    country: "England", 
    league: "League Two", 
    lat: 51.1099, 
    lng: -0.1872, 
    city: "Crawley",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Crawley_Town_FC_logo.svg"
  },
  { 
    id: 256, 
    name: "Exeter City", 
    country: "England", 
    league: "League One", 
    lat: 50.7184, 
    lng: -3.5339, 
    city: "Exeter",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Exeter_City_FC_logo.svg"
  },
  { 
    id: 257, 
    name: "Wigan Athletic", 
    country: "England", 
    league: "League One", 
    lat: 53.5456, 
    lng: -2.6531, 
    city: "Wigan",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Wigan_Athletic_FC_logo.svg"
  },
  { 
    id: 258, 
    name: "Dynamo Dresden", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 51.0504, 
    lng: 13.7373, 
    city: "Dresden",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Dynamo_Dresden_logo.svg"
  },
  { 
    id: 259, 
    name: "Grasshopper", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 47.3769, 
    lng: 8.5417, 
    city: "Zurich",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Grasshopper_Club_Z%C3%BCrich_logo.svg"
  },
  { 
    id: 260, 
    name: "SV Ried", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 48.21, 
    lng: 13.48, 
    city: "Ried im Innkreis",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Ried_logo.svg"
  },
  { 
    id: 261, 
    name: "Gil Vicente", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 41.4425, 
    lng: -8.5358, 
    city: "Barcelos",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Gil_Vicente_FC_logo.svg"
  },
  { 
    id: 262, 
    name: "Union St-Gilloise", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8503, 
    lng: 4.3517, 
    city: "Brussels",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Union_Saint-Gilloise_logo.svg"
  },
  { 
    id: 263, 
    name: "Zulte Waregem", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8833, 
    lng: 3.4333, 
    city: "Waregem",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Zulte_Waregem_logo.svg"
  },
  { 
    id: 264, 
    name: "Panathinaikos", 
    country: "Greece", 
    league: "Super League", 
    lat: 37.9755, 
    lng: 23.7348, 
    city: "Athens",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Panathinaikos_FC_logo.svg"
  },
  { 
    id: 265, 
    name: "Partizan Belgrade", 
    country: "Serbia", 
    league: "Serbian SuperLiga", 
    lat: 44.7866, 
    lng: 20.4489, 
    city: "Belgrade",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FK_Partizan_logo.svg"
  },
  { 
    id: 266, 
    name: "Laval", 
    country: "France", 
    league: "Ligue 2", 
    lat: 48.0736, 
    lng: -0.7694, 
    city: "Laval",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Stade_Lavallois_logo.svg"
  },
  { 
    id: 267, 
    name: "Sparta Prague", 
    country: "Czech Republic", 
    league: "Fortuna Liga", 
    lat: 50.0755, 
    lng: 14.4378, 
    city: "Prague",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Sparta_Prague_logo.svg"
  },
  { 
    id: 268, 
    name: "Los Angeles FC", 
    country: "USA", 
    league: "MLS", 
    lat: 34.0522, 
    lng: -118.2437, 
    city: "Los Angeles",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Los_Angeles_FC_logo.svg"
  },
  { 
    id: 269, 
    name: "Saarbrücken", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 49.2406, 
    lng: 6.9969, 
    city: "Saarbrücken",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/1._FC_Saarbr%C3%BCcken_logo.svg"
  },
  { 
    id: 270, 
    name: "Sporting Gijón", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 43.5453, 
    lng: -5.6619, 
    city: "Gijón",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Real_Sporting_de_Gij%C3%B3n_logo.svg"
  },
  { 
    id: 271, 
    name: "Wimbledon", 
    country: "England", 
    league: "League Two", 
    lat: 51.4342, 
    lng: -0.2141, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AFC_Wimbledon_logo.svg"
  },
  { 
    id: 272, 
    name: "Servette", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 46.2044, 
    lng: 6.1432, 
    city: "Geneva",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Servette_FC_logo.svg"
  },
  { 
    id: 273, 
    name: "Walsall", 
    country: "England", 
    league: "League Two", 
    lat: 52.586, 
    lng: -1.9829, 
    city: "Walsall",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Walsall_FC_logo.svg"
  },
  { 
    id: 274, 
    name: "Eintracht Braunschweig", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 52.2689, 
    lng: 10.5267, 
    city: "Braunschweig",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Eintracht_Braunschweig_logo.svg"
  },
  { 
    id: 275, 
    name: "Bahia", 
    country: "Brazil", 
    league: "Série A", 
    lat: -12.9714, 
    lng: -38.5014, 
    city: "Salvador",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/EC_Bahia_logo.svg"
  },
  { 
    id: 276, 
    name: "Sivasspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 39.7477, 
    lng: 37.0179, 
    city: "Sivas",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Sivasspor_logo.svg"
  },
  { 
    id: 277, 
    name: "Real Zaragoza", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 41.6488, 
    lng: -0.8891, 
    city: "Zaragoza",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Real_Zaragoza_logo.svg"
  },
  { 
    id: 278, 
    name: "Burgos", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 42.3409, 
    lng: -3.6997, 
    city: "Burgos",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Burgos_CF_logo.svg"
  },
  { 
    id: 279, 
    name: "Maribor", 
    country: "Slovenia", 
    league: "PrvaLiga", 
    lat: 46.5547, 
    lng: 15.6467, 
    city: "Maribor",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/NK_Maribor_logo.svg"
  },
  { 
    id: 280, 
    name: "Universidad Católica", 
    country: "Chile", 
    league: "Primera División", 
    lat: -33.4489, 
    lng: -70.6693, 
    city: "Santiago",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Universidad_Cat%C3%B3lica_logo.svg"
  },
  { 
    id: 281, 
    name: "Neom SC", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 28.3998, 
    lng: 36.57, 
    city: "Neom",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Neom_SC_logo.svg"
  },
  { 
    id: 282, 
    name: "Lausanne", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 46.5197, 
    lng: 6.6323, 
    city: "Lausanne",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Lausanne-Sport_logo.svg"
  },
  { 
    id: 283, 
    name: "Widzew Lodz", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 51.7592, 
    lng: 19.456, 
    city: "Łódź",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Widzew_%C5%81%C3%B3d%C5%BA_logo.svg"
  },
  { 
    id: 284, 
    name: "OFI Crete", 
    country: "Greece", 
    league: "Super League", 
    lat: 35.3081, 
    lng: 25.0775, 
    city: "Heraklion",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/OFI_Crete_logo.svg"
  },
  { 
    id: 285, 
    name: "Standard Liège", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.6403, 
    lng: 5.5717, 
    city: "Liège",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Standard_Li%C3%A8ge_logo.svg"
  },
  { 
    id: 286, 
    name: "Pachuca", 
    country: "Mexico", 
    league: "Liga MX", 
    lat: 20.123, 
    lng: -98.7335, 
    city: "Pachuca",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CF_Pachuca_logo.svg"
  },
  { 
    id: 287, 
    name: "Seraing", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.6117, 
    lng: 5.5019, 
    city: "Seraing",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RFC_Seraing_logo.svg"
  },
  { 
    id: 288, 
    name: "Jahn Regensburg", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 49.0134, 
    lng: 12.1016, 
    city: "Regensburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SSV_Jahn_Regensburg_logo.svg"
  },
  { 
    id: 289, 
    name: "Chesterfield", 
    country: "England", 
    league: "League Two", 
    lat: 53.235, 
    lng: -1.4216, 
    city: "Chesterfield",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Chesterfield_FC_logo.svg"
  },
  { 
    id: 290, 
    name: "Benevento", 
    country: "Italy", 
    league: "Serie B", 
    lat: 41.1295, 
    lng: 14.7821, 
    city: "Benevento",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Benevento_Calcio_logo.svg"
  },
  { 
    id: 291, 
    name: "Eldense", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 38.8378, 
    lng: -0.1053, 
    city: "Elda",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Eldense_logo.svg"
  },
  { 
    id: 292, 
    name: "Artis Brno", 
    country: "Czech Republic", 
    league: "Fortuna Liga", 
    lat: 49.1951, 
    lng: 16.6068, 
    city: "Brno",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Zbrojovka_Brno_logo.svg"
  },
  { 
    id: 293, 
    name: "Samsunspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.2928, 
    lng: 36.3313, 
    city: "Samsun",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Samsunspor_logo.svg"
  },
  { 
    id: 294, 
    name: "Alverca", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 38.8961, 
    lng: -9.0356, 
    city: "Alverca do Ribatejo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Alverca_logo.svg"
  },
  { 
    id: 295, 
    name: "Padova", 
    country: "Italy", 
    league: "Serie C", 
    lat: 45.4064, 
    lng: 11.8769, 
    city: "Padua",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Calcio_Padova_logo.svg"
  },
  { 
    id: 296, 
    name: "Cerro Porteño", 
    country: "Paraguay", 
    league: "Primera División", 
    lat: -25.2637, 
    lng: -57.5759, 
    city: "Asunción",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Cerro_Porte%C3%B1o_logo.svg"
  },
  { 
    id: 297, 
    name: "Sheffield United", 
    country: "England", 
    league: "Championship", 
    lat: 53.3703, 
    lng: -1.4707, 
    city: "Sheffield",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Sheffield_United_FC_logo.svg"
  },
  { 
    id: 298, 
    name: "Stoke City", 
    country: "England", 
    league: "Championship", 
    lat: 53.0027, 
    lng: -2.1794, 
    city: "Stoke-on-Trent",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Stoke_City_FC_logo.svg"
  },
  { 
    id: 299, 
    name: "Aberdeen", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 57.1497, 
    lng: -2.0943, 
    city: "Aberdeen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Aberdeen_FC_logo.svg"
  },
  { 
    id: 300, 
    name: "Torres", 
    country: "Italy", 
    league: "Serie C", 
    lat: 40.8333, 
    lng: 8.4, 
    city: "Sassari",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SS_Torres_logo.svg"
  },
  { 
    id: 301, 
    name: "AGF", 
    country: "Denmark", 
    league: "Superligaen", 
    lat: 56.1572, 
    lng: 10.2107, 
    city: "Aarhus",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Aarhus_GF_logo.svg"
  },
  { 
    id: 302, 
    name: "Mantova", 
    country: "Italy", 
    league: "Serie C", 
    lat: 45.1667, 
    lng: 10.7833, 
    city: "Mantua",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Mantova_logo.svg"
  }
,

  // Additional clubs from transfers (Batch 4)
  { 
    id: 303, 
    name: "Francs Borains", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.4833, 
    lng: 3.9333, 
    city: "Boussu",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RFC_Borains_logo.svg"
  },
  { 
    id: 304, 
    name: "Johor Darul Ta'zim", 
    country: "Malaysia", 
    league: "Super League", 
    lat: 1.4927, 
    lng: 103.7414, 
    city: "Johor Bahru",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Johor_Darul_Ta%27zim_FC_logo.svg"
  },
  { 
    id: 305, 
    name: "Bandirmaspor", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 40.35, 
    lng: 27.9667, 
    city: "Bandırma",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Band%C4%B1rmaspor_logo.svg"
  },
  { 
    id: 306, 
    name: "Pergolettese", 
    country: "Italy", 
    league: "Serie C", 
    lat: 45.5833, 
    lng: 9.6167, 
    city: "Pergoleto",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Pergolettese_1932_logo.svg"
  },
  { 
    id: 307, 
    name: "Reading", 
    country: "England", 
    league: "League One", 
    lat: 51.4543, 
    lng: -0.9781, 
    city: "Reading",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Reading_FC_logo.svg"
  },
  { 
    id: 308, 
    name: "Ceuta", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 35.8889, 
    lng: -5.3167, 
    city: "Ceuta",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AD_Ceuta_FC_logo.svg"
  },
  { 
    id: 309, 
    name: "Kocaelispor", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 40.7654, 
    lng: 29.9408, 
    city: "İzmit",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kocaelispor_logo.svg"
  },
  { 
    id: 310, 
    name: "Hannover 96", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 52.3759, 
    lng: 9.732, 
    city: "Hannover",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Hannover_96_logo.svg"
  },
  { 
    id: 311, 
    name: "Recreativo de Huelva", 
    country: "Spain", 
    league: "Segunda División RFEF", 
    lat: 37.2583, 
    lng: -6.9508, 
    city: "Huelva",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Recreativo_de_Huelva_logo.svg"
  },
  { 
    id: 312, 
    name: "Kawasaki Frontale", 
    country: "Japan", 
    league: "J1 League", 
    lat: 35.53, 
    lng: 139.7, 
    city: "Kawasaki",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kawasaki_Frontale_logo.svg"
  },
  { 
    id: 313, 
    name: "Rosario Central", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -32.9442, 
    lng: -60.6505, 
    city: "Rosario",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_Rosario_Central_logo.svg"
  },
  { 
    id: 314, 
    name: "Palermo", 
    country: "Italy", 
    league: "Serie B", 
    lat: 38.1157, 
    lng: 13.3613, 
    city: "Palermo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Palermo_FC_logo.svg"
  },
  { 
    id: 315, 
    name: "Corinthians", 
    country: "Brazil", 
    league: "Série A", 
    lat: -23.5505, 
    lng: -46.6333, 
    city: "São Paulo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Corinthians_Paulista_logo.svg"
  },
  { 
    id: 316, 
    name: "Al-Hilal", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 24.7136, 
    lng: 46.6753, 
    city: "Riyadh",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Hilal_FC_logo.svg"
  },
  { 
    id: 317, 
    name: "Notts County", 
    country: "England", 
    league: "League Two", 
    lat: 52.9548, 
    lng: -1.1581, 
    city: "Nottingham",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Notts_County_FC_logo.svg"
  },
  { 
    id: 318, 
    name: "Luton Town", 
    country: "England", 
    league: "Premier League", 
    lat: 51.8787, 
    lng: -0.42, 
    city: "Luton",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Luton_Town_FC_logo.svg"
  },
  { 
    id: 319, 
    name: "Istanbul Basaksehir", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/%C4%B0stanbul_Ba%C5%9Fak%C5%9Fehir_FK_logo.svg"
  },
  { 
    id: 320, 
    name: "Dynamo Kyiv", 
    country: "Ukraine", 
    league: "Premier League", 
    lat: 50.4501, 
    lng: 30.5234, 
    city: "Kyiv",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Dynamo_Kyiv_logo.svg"
  },
  { 
    id: 321, 
    name: "Frosinone", 
    country: "Italy", 
    league: "Serie A", 
    lat: 41.64, 
    lng: 13.35, 
    city: "Frosinone",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Frosinone_Calcio_logo.svg"
  },
  { 
    id: 322, 
    name: "New York City", 
    country: "USA", 
    league: "MLS", 
    lat: 40.7128, 
    lng: -74.006, 
    city: "New York",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/New_York_City_FC_logo.svg"
  },
  { 
    id: 323, 
    name: "Aris Saloniki", 
    country: "Greece", 
    league: "Super League", 
    lat: 40.6401, 
    lng: 22.9444, 
    city: "Thessaloniki",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Aris_FC_logo.svg"
  },
  { 
    id: 324, 
    name: "Racing Club", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -34.635, 
    lng: -58.3651, 
    city: "Buenos Aires",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Racing_Club_logo.svg"
  },
  { 
    id: 325, 
    name: "Albacete", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 38.9942, 
    lng: -1.8564, 
    city: "Albacete",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Albacete_Balompi%C3%A9_logo.svg"
  },
  { 
    id: 326, 
    name: "Marítimo", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 32.6669, 
    lng: -16.9244, 
    city: "Funchal",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CS_Mar%C3%ADtimo_logo.svg"
  },
  { 
    id: 327, 
    name: "Clermont Foot", 
    country: "France", 
    league: "Ligue 1", 
    lat: 45.7772, 
    lng: 3.087, 
    city: "Clermont-Ferrand",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Clermont_Foot_63_logo.svg"
  },
  { 
    id: 328, 
    name: "Vejle", 
    country: "Denmark", 
    league: "Superligaen", 
    lat: 55.7093, 
    lng: 9.5357, 
    city: "Vejle",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Vejle_BK_logo.svg"
  },
  { 
    id: 329, 
    name: "Almería", 
    country: "Spain", 
    league: "La Liga", 
    lat: 36.8381, 
    lng: -2.4597, 
    city: "Almería",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/UD_Almer%C3%ADa_logo.svg"
  },
  { 
    id: 330, 
    name: "Al-Gharafa", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.2854, 
    lng: 51.531, 
    city: "Doha",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Gharafa_SC_logo.svg"
  },
  { 
    id: 331, 
    name: "Salernitana", 
    country: "Italy", 
    league: "Serie A", 
    lat: 40.6821, 
    lng: 14.7681, 
    city: "Salerno",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Salernitana_1919_logo.svg"
  },
  { 
    id: 332, 
    name: "Pianese", 
    country: "Italy", 
    league: "Serie C", 
    lat: 43.25, 
    lng: 11.3333, 
    city: "Piancastagnaio",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Pianese_logo.svg"
  },
  { 
    id: 333, 
    name: "Crewe", 
    country: "England", 
    league: "League Two", 
    lat: 53.0975, 
    lng: -2.4411, 
    city: "Crewe",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Crewe_Alexandra_FC_logo.svg"
  },
  { 
    id: 334, 
    name: "Amiens", 
    country: "France", 
    league: "Ligue 2", 
    lat: 49.8943, 
    lng: 2.2958, 
    city: "Amiens",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Amiens_SC_logo.svg"
  },
  { 
    id: 335, 
    name: "FC Andorra", 
    country: "Andorra", 
    league: "Segunda División", 
    lat: 42.5063, 
    lng: 1.5218, 
    city: "Andorra la Vella",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Andorra_logo.svg"
  },
  { 
    id: 336, 
    name: "Avellino", 
    country: "Italy", 
    league: "Serie C", 
    lat: 40.9142, 
    lng: 14.7881, 
    city: "Avellino",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Avellino_1912_logo.svg"
  },
  { 
    id: 337, 
    name: "Dunkerque", 
    country: "France", 
    league: "Ligue 2", 
    lat: 51.0344, 
    lng: 2.3769, 
    city: "Dunkirk",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/USL_Dunkerque_logo.svg"
  },
  { 
    id: 338, 
    name: "Young Boys", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 46.9481, 
    lng: 7.4476, 
    city: "Bern",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/BSC_Young_Boys_logo.svg"
  },
  { 
    id: 339, 
    name: "Beveren", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.2167, 
    lng: 4.25, 
    city: "Beveren",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Waasland-Beveren_logo.svg"
  },
  { 
    id: 340, 
    name: "AVS", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 40.6406, 
    lng: -8.6538, 
    city: "Aveiro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AVS_Futebol_SAD_logo.svg"
  },
  { 
    id: 341, 
    name: "Rakow", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 50.8, 
    lng: 19.1167, 
    city: "Częstochowa",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RKS_Rak%C3%B3w_Cz%C4%99stochowa_logo.svg"
  },
  { 
    id: 342, 
    name: "Wycombe", 
    country: "England", 
    league: "League One", 
    lat: 51.6286, 
    lng: -0.7482, 
    city: "High Wycombe",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Wycombe_Wanderers_FC_logo.svg"
  },
  { 
    id: 343, 
    name: "Blackpool", 
    country: "England", 
    league: "League One", 
    lat: 53.8175, 
    lng: -3.0353, 
    city: "Blackpool",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Blackpool_FC_logo.svg"
  },
  { 
    id: 344, 
    name: "Slavia Prague", 
    country: "Czech Republic", 
    league: "Fortuna Liga", 
    lat: 50.0755, 
    lng: 14.4378, 
    city: "Prague",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SK_Slavia_Prague_logo.svg"
  },
  { 
    id: 345, 
    name: "Excelsior", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51.9244, 
    lng: 4.4778, 
    city: "Rotterdam",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SBV_Excelsior_logo.svg"
  },
  { 
    id: 346, 
    name: "Bromley", 
    country: "England", 
    league: "National League", 
    lat: 51.405, 
    lng: 0.0142, 
    city: "Bromley",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Bromley_FC_logo.svg"
  },
  { 
    id: 347, 
    name: "Al-Wasl", 
    country: "UAE", 
    league: "UAE Pro League", 
    lat: 25.2048, 
    lng: 55.2708, 
    city: "Dubai",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Wasl_FC_logo.svg"
  },
  { 
    id: 348, 
    name: "Al-Ahli Doha", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.2854, 
    lng: 51.531, 
    city: "Doha",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Ahli_Doha_logo.svg"
  },
  { 
    id: 349, 
    name: "Ettifaq", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 26.4207, 
    lng: 50.0888, 
    city: "Dammam",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Ettifaq_FC_logo.svg"
  },
  { 
    id: 350, 
    name: "Reggiana", 
    country: "Italy", 
    league: "Serie B", 
    lat: 44.6989, 
    lng: 10.6296, 
    city: "Reggio Emilia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Reggiana_1919_logo.svg"
  },
  { 
    id: 351, 
    name: "Pontedera", 
    country: "Italy", 
    league: "Serie C", 
    lat: 43.6614, 
    lng: 10.6311, 
    city: "Pontedera",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Pontedera_logo.svg"
  },
  { 
    id: 352, 
    name: "Ingolstadt", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 48.7665, 
    lng: 11.4258, 
    city: "Ingolstadt",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Ingolstadt_04_logo.svg"
  }
,

  // Additional clubs from transfers (Batch 5)
  { 
    id: 353, 
    name: "Modena", 
    country: "Italy", 
    league: "Serie B", 
    lat: 44.6471, 
    lng: 10.9252, 
    city: "Modena",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Modena_FC_logo.svg"
  },
  { 
    id: 354, 
    name: "Racing Ferrol", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 43.4883, 
    lng: -8.2369, 
    city: "Ferrol",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Racing_de_Ferrol_logo.svg"
  },
  { 
    id: 355, 
    name: "Rotherham", 
    country: "England", 
    league: "Championship", 
    lat: 53.4302, 
    lng: -1.3568, 
    city: "Rotherham",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Rotherham_United_FC_logo.svg"
  },
  { 
    id: 356, 
    name: "Bari", 
    country: "Italy", 
    league: "Serie B", 
    lat: 41.1177, 
    lng: 16.8719, 
    city: "Bari",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AS_Bari_logo.svg"
  },
  { 
    id: 357, 
    name: "Huesca", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 42.1364, 
    lng: -0.4087, 
    city: "Huesca",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SD_Huesca_logo.svg"
  },
  { 
    id: 358, 
    name: "Trento", 
    country: "Italy", 
    league: "Serie C", 
    lat: 46.0748, 
    lng: 11.1217, 
    city: "Trento",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Trento_1921_logo.svg"
  },
  { 
    id: 359, 
    name: "Alanyaspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 36.544, 
    lng: 32, 
    city: "Alanya",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Alanyaspor_logo.svg"
  },
  { 
    id: 360, 
    name: "Nancy", 
    country: "France", 
    league: "Ligue 2", 
    lat: 48.6921, 
    lng: 6.1844, 
    city: "Nancy",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AS_Nancy_Lorraine_logo.svg"
  },
  { 
    id: 361, 
    name: "Talleres", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -31.4201, 
    lng: -64.1888, 
    city: "Córdoba",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_Talleres_logo.svg"
  },
  { 
    id: 362, 
    name: "Al-Khaleej", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 26.4207, 
    lng: 50.0888, 
    city: "Dammam",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Khaleej_FC_logo.svg"
  },
  { 
    id: 363, 
    name: "Carrarese", 
    country: "Italy", 
    league: "Serie C", 
    lat: 44.0793, 
    lng: 10.0978, 
    city: "Carrara",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Carrarese_Calcio_logo.svg"
  },
  { 
    id: 364, 
    name: "Lugano", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 46.0101, 
    lng: 8.96, 
    city: "Lugano",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Lugano_logo.svg"
  },
  { 
    id: 365, 
    name: "Crotone", 
    country: "Italy", 
    league: "Serie C", 
    lat: 39.0808, 
    lng: 17.1272, 
    city: "Crotone",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Crotone_logo.svg"
  },
  { 
    id: 366, 
    name: "Preußen Münster", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 51.9607, 
    lng: 7.6261, 
    city: "Münster",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Preu%C3%9Fen_M%C3%BCnster_logo.svg"
  },
  { 
    id: 367, 
    name: "Mechelen", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.0259, 
    lng: 4.4776, 
    city: "Mechelen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/KV_Mechelen_logo.svg"
  },
  { 
    id: 368, 
    name: "FC Zurich", 
    country: "Switzerland", 
    league: "Super League", 
    lat: 47.3769, 
    lng: 8.5417, 
    city: "Zurich",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Z%C3%BCrich_logo.svg"
  },
  { 
    id: 369, 
    name: "Kolkheti Poti", 
    country: "Georgia", 
    league: "Erovnuli Liga", 
    lat: 42.1466, 
    lng: 41.6719, 
    city: "Poti",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Kolkheti_Poti_logo.svg"
  },
  { 
    id: 370, 
    name: "Nacional (Uruguay)", 
    country: "Uruguay", 
    league: "Primera División", 
    lat: -34.9011, 
    lng: -56.1645, 
    city: "Montevideo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Club_Nacional_de_Football_logo.svg"
  },
  { 
    id: 371, 
    name: "Tondela", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 40.5167, 
    lng: -8.0833, 
    city: "Tondela",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CD_Tondela_logo.svg"
  },
  { 
    id: 372, 
    name: "Lech Poznan", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 52.4064, 
    lng: 16.9252, 
    city: "Poznań",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Lech_Pozna%C5%84_logo.svg"
  },
  { 
    id: 373, 
    name: "Barnet", 
    country: "England", 
    league: "National League", 
    lat: 51.6526, 
    lng: -0.201, 
    city: "London",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Barnet_FC_logo.svg"
  },
  { 
    id: 374, 
    name: "Shelbourne", 
    country: "Ireland", 
    league: "Premier Division", 
    lat: 53.3498, 
    lng: -6.2603, 
    city: "Dublin",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Shelbourne_FC_logo.svg"
  },
  { 
    id: 375, 
    name: "Toronto FC", 
    country: "Canada", 
    league: "MLS", 
    lat: 43.6532, 
    lng: -79.3832, 
    city: "Toronto",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Toronto_FC_logo.svg"
  },
  { 
    id: 376, 
    name: "Caykur Rizespor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0201, 
    lng: 40.5234, 
    city: "Rize",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/%C3%87aykur_Rizespor_logo.svg"
  },
  { 
    id: 377, 
    name: "Brescia", 
    country: "Italy", 
    league: "Serie B", 
    lat: 45.5416, 
    lng: 10.2118, 
    city: "Brescia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Brescia_Calcio_logo.svg"
  },
  { 
    id: 378, 
    name: "Catanzaro", 
    country: "Italy", 
    league: "Serie B", 
    lat: 38.9107, 
    lng: 16.5877, 
    city: "Catanzaro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/US_Catanzaro_1929_logo.svg"
  },
  { 
    id: 379, 
    name: "Al-Wakrah", 
    country: "Qatar", 
    league: "Qatar Stars League", 
    lat: 25.1711, 
    lng: 51.6031, 
    city: "Al Wakrah",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Wakrah_SC_logo.svg"
  },
  { 
    id: 380, 
    name: "Independiente Santa Fe", 
    country: "Colombia", 
    league: "Primera A", 
    lat: 4.711, 
    lng: -74.0721, 
    city: "Bogotá",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Independiente_Santa_Fe_logo.svg"
  },
  { 
    id: 381, 
    name: "Kilmarnock", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 55.6117, 
    lng: -4.4958, 
    city: "Kilmarnock",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kilmarnock_FC_logo.svg"
  },
  { 
    id: 382, 
    name: "Burton Albion", 
    country: "England", 
    league: "League One", 
    lat: 52.8019, 
    lng: -1.6361, 
    city: "Burton upon Trent",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Burton_Albion_FC_logo.svg"
  },
  { 
    id: 383, 
    name: "Newport County", 
    country: "England", 
    league: "League Two", 
    lat: 51.5889, 
    lng: -2.9978, 
    city: "Newport",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Newport_County_AFC_logo.svg"
  },
  { 
    id: 384, 
    name: "Coleraine", 
    country: "Northern Ireland", 
    league: "NIFL Premiership", 
    lat: 55.1333, 
    lng: -6.6667, 
    city: "Coleraine",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Coleraine_FC_logo.svg"
  },
  { 
    id: 385, 
    name: "Concord Rangers", 
    country: "England", 
    league: "National League South", 
    lat: 51.5, 
    lng: 0.7, 
    city: "Canvey Island",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Concord_Rangers_FC_logo.svg"
  },
  { 
    id: 386, 
    name: "Giana Erminio", 
    country: "Italy", 
    league: "Serie C", 
    lat: 45.5833, 
    lng: 9.6167, 
    city: "Gorgonzola",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AS_Giana_Erminio_logo.svg"
  },
  { 
    id: 387, 
    name: "Monopoli", 
    country: "Italy", 
    league: "Serie C", 
    lat: 40.95, 
    lng: 17.3, 
    city: "Monopoli",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SS_Monopoli_1966_logo.svg"
  },
  { 
    id: 388, 
    name: "Virtus Entella", 
    country: "Italy", 
    league: "Serie C", 
    lat: 44.1667, 
    lng: 9.3833, 
    city: "Chiavari",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Virtus_Entella_logo.svg"
  },
  { 
    id: 389, 
    name: "Karpaty Lviv", 
    country: "Ukraine", 
    league: "Premier League", 
    lat: 49.8397, 
    lng: 24.0297, 
    city: "Lviv",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FK_Karpaty_Lviv_logo.svg"
  },
  { 
    id: 390, 
    name: "Al-Qadsiah", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 26.4207, 
    lng: 50.0888, 
    city: "Dammam",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Qadsiah_FC_logo.svg"
  },
  { 
    id: 391, 
    name: "Al-Diriyah", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 24.7136, 
    lng: 46.6753, 
    city: "Riyadh",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Diriyah_FC_logo.svg"
  },
  { 
    id: 392, 
    name: "Red Star", 
    country: "France", 
    league: "Championnat National", 
    lat: 48.8566, 
    lng: 2.3522, 
    city: "Paris",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Red_Star_FC_logo.svg"
  },
  { 
    id: 393, 
    name: "Fluminense", 
    country: "Brazil", 
    league: "Série A", 
    lat: -22.9068, 
    lng: -43.1729, 
    city: "Rio de Janeiro",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fluminense_FC_logo.svg"
  },
  { 
    id: 394, 
    name: "Suwon Bluewings", 
    country: "South Korea", 
    league: "K League 1", 
    lat: 37.2636, 
    lng: 127.0286, 
    city: "Suwon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Suwon_Samsung_Bluewings_logo.svg"
  },
  { 
    id: 395, 
    name: "Ajaccio", 
    country: "France", 
    league: "Ligue 2", 
    lat: 41.9267, 
    lng: 8.7369, 
    city: "Ajaccio",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Ajaccio_logo.svg"
  },
  { 
    id: 396, 
    name: "Juve Stabia", 
    country: "Italy", 
    league: "Serie C", 
    lat: 40.6944, 
    lng: 14.49, 
    city: "Castellammare di Stabia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SS_Juve_Stabia_logo.svg"
  },
  { 
    id: 397, 
    name: "CF Montréal", 
    country: "Canada", 
    league: "MLS", 
    lat: 45.5017, 
    lng: -73.5673, 
    city: "Montreal",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CF_Montr%C3%A9al_logo.svg"
  },
  { 
    id: 398, 
    name: "Salford City", 
    country: "England", 
    league: "League Two", 
    lat: 53.4833, 
    lng: -2.2833, 
    city: "Salford",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Salford_City_FC_logo.svg"
  },
  { 
    id: 399, 
    name: "Pescara", 
    country: "Italy", 
    league: "Serie C", 
    lat: 42.4584, 
    lng: 14.2138, 
    city: "Pescara",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Delfino_Pescara_1936_logo.svg"
  },
  { 
    id: 400, 
    name: "Colorado Rapids", 
    country: "USA", 
    league: "MLS", 
    lat: 39.7392, 
    lng: -104.9903, 
    city: "Denver",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Colorado_Rapids_logo.svg"
  },
  { 
    id: 401, 
    name: "Austria Vienna", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 48.2082, 
    lng: 16.3738, 
    city: "Vienna",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FK_Austria_Wien_logo.svg"
  },
  { 
    id: 402, 
    name: "Arouca", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 40.9333, 
    lng: -8.25, 
    city: "Arouca",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Arouca_logo.svg"
  }
,

  // Additional clubs from transfers (Final Batch)
  { 
    id: 403, 
    name: "Wrexham", 
    country: "Wales", 
    league: "League Two", 
    lat: 53.046, 
    lng: -2.993, 
    city: "Wrexham",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Wrexham_AFC_logo.svg"
  },
  { 
    id: 404, 
    name: "Bradford City", 
    country: "England", 
    league: "League Two", 
    lat: 53.796, 
    lng: -1.7594, 
    city: "Bradford",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Bradford_City_AFC_logo.svg"
  },
  { 
    id: 405, 
    name: "Shrewsbury Town", 
    country: "England", 
    league: "League One", 
    lat: 52.7069, 
    lng: -2.7528, 
    city: "Shrewsbury",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Shrewsbury_Town_FC_logo.svg"
  },
  { 
    id: 406, 
    name: "Barnsley", 
    country: "England", 
    league: "League One", 
    lat: 53.5526, 
    lng: -1.4792, 
    city: "Barnsley",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Barnsley_FC_logo.svg"
  },
  { 
    id: 407, 
    name: "Derby County", 
    country: "England", 
    league: "League One", 
    lat: 52.9147, 
    lng: -1.4481, 
    city: "Derby",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Derby_County_FC_logo.svg"
  },
  { 
    id: 408, 
    name: "Blackburn Rovers", 
    country: "England", 
    league: "Championship", 
    lat: 53.75, 
    lng: -2.4833, 
    city: "Blackburn",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Blackburn_Rovers_FC_logo.svg"
  },
  { 
    id: 409, 
    name: "Pau", 
    country: "France", 
    league: "Ligue 2", 
    lat: 43.2951, 
    lng: -0.3707, 
    city: "Pau",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Pau_FC_logo.svg"
  },
  { 
    id: 410, 
    name: "Casa Pia", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 38.7223, 
    lng: -9.1393, 
    city: "Lisbon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Casa_Pia_AC_logo.svg"
  },
  { 
    id: 411, 
    name: "La Louvière", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.4833, 
    lng: 4.1833, 
    city: "La Louvière",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/La_Louvi%C3%A8re_Centre_logo.svg"
  },
  { 
    id: 412, 
    name: "Oxford United", 
    country: "England", 
    league: "League One", 
    lat: 51.752, 
    lng: -1.2577, 
    city: "Oxford",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Oxford_United_FC_logo.svg"
  },
  { 
    id: 413, 
    name: "Inter Miami", 
    country: "USA", 
    league: "MLS", 
    lat: 25.7617, 
    lng: -80.1918, 
    city: "Miami",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Inter_Miami_CF_logo.svg"
  },
  { 
    id: 414, 
    name: "Hatayspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 36.4018, 
    lng: 36.3498, 
    city: "Antakya",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Hatayspor_logo.svg"
  },
  { 
    id: 415, 
    name: "Antalyaspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 36.8969, 
    lng: 30.7133, 
    city: "Antalya",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Antalyaspor_logo.svg"
  },
  { 
    id: 416, 
    name: "Osijek", 
    country: "Croatia", 
    league: "Hrvatska nogometna liga", 
    lat: 45.555, 
    lng: 18.6955, 
    city: "Osijek",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/NK_Osijek_logo.svg"
  },
  { 
    id: 417, 
    name: "Brommapojkarna", 
    country: "Sweden", 
    league: "Allsvenskan", 
    lat: 59.3293, 
    lng: 18.0686, 
    city: "Stockholm",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/IF_Brommapojkarna_logo.svg"
  },
  { 
    id: 418, 
    name: "Apoel Nicosia", 
    country: "Cyprus", 
    league: "First Division", 
    lat: 35.1856, 
    lng: 33.3823, 
    city: "Nicosia",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/APOEL_FC_logo.svg"
  },
  { 
    id: 419, 
    name: "Ethnikos Achna", 
    country: "Cyprus", 
    league: "First Division", 
    lat: 35.055, 
    lng: 33.7833, 
    city: "Achna",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Ethnikos_Achna_FC_logo.svg"
  },
  { 
    id: 420, 
    name: "Bristol City", 
    country: "England", 
    league: "Championship", 
    lat: 51.4545, 
    lng: -2.5879, 
    city: "Bristol",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Bristol_City_FC_logo.svg"
  },
  { 
    id: 421, 
    name: "Magdeburg", 
    country: "Germany", 
    league: "2. Bundesliga", 
    lat: 52.1205, 
    lng: 11.6276, 
    city: "Magdeburg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/1._FC_Magdeburg_logo.svg"
  },
  { 
    id: 422, 
    name: "Radomiak Radom", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 51.4025, 
    lng: 21.1471, 
    city: "Radom",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Radomiak_Radom_logo.svg"
  },
  { 
    id: 423, 
    name: "Piast Gliwice", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 50.3014, 
    lng: 18.6498, 
    city: "Gliwice",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/KS_Piast_Gliwice_logo.svg"
  },
  { 
    id: 424, 
    name: "Fortuna Sittard", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51, 
    lng: 5.8667, 
    city: "Sittard",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fortuna_Sittard_logo.svg"
  },
  { 
    id: 425, 
    name: "Cambuur", 
    country: "Netherlands", 
    league: "Eerste Divisie", 
    lat: 53.2194, 
    lng: 5.7833, 
    city: "Leeuwarden",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Cambuur_logo.svg"
  },
  { 
    id: 426, 
    name: "Fredrikstad", 
    country: "Norway", 
    league: "Eliteserien", 
    lat: 59.2181, 
    lng: 10.9378, 
    city: "Fredrikstad",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Fredrikstad_FK_logo.svg"
  },
  { 
    id: 427, 
    name: "Deportivo La Coruña", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 43.3623, 
    lng: -8.4115, 
    city: "A Coruña",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RC_Deportivo_de_La_Coru%C3%B1a_logo.svg"
  },
  { 
    id: 428, 
    name: "Casertana", 
    country: "Italy", 
    league: "Serie C", 
    lat: 41.1167, 
    lng: 14.3333, 
    city: "Caserta",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Casertana_FC_logo.svg"
  },
  { 
    id: 429, 
    name: "Dordrecht", 
    country: "Netherlands", 
    league: "Eerste Divisie", 
    lat: 51.8131, 
    lng: 4.6736, 
    city: "Dordrecht",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Dordrecht_logo.svg"
  },
  { 
    id: 430, 
    name: "Kyoto Sanga", 
    country: "Japan", 
    league: "J1 League", 
    lat: 35.0116, 
    lng: 135.7681, 
    city: "Kyoto",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kyoto_Sanga_FC_logo.svg"
  },
  { 
    id: 431, 
    name: "TSV Solingen", 
    country: "Germany", 
    league: "Oberliga", 
    lat: 51.1711, 
    lng: 7.0844, 
    city: "Solingen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/TSV_Solingen_logo.svg"
  },
  { 
    id: 432, 
    name: "Östers IF", 
    country: "Sweden", 
    league: "Superettan", 
    lat: 57.6706, 
    lng: 14.6964, 
    city: "Växjö",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/%C3%96sters_IF_logo.svg"
  },
  { 
    id: 433, 
    name: "SC Verl", 
    country: "Germany", 
    league: "3. Liga", 
    lat: 51.8833, 
    lng: 8.5167, 
    city: "Verl",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SC_Verl_logo.svg"
  },
  { 
    id: 434, 
    name: "Wacker Burghausen", 
    country: "Germany", 
    league: "Regionalliga", 
    lat: 48.0167, 
    lng: 12.8167, 
    city: "Burghausen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/SV_Wacker_Burghausen_logo.svg"
  },
  { 
    id: 435, 
    name: "NEC Nijmegen", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51.8426, 
    lng: 5.8611, 
    city: "Nijmegen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/NEC_Nijmegen_logo.svg"
  },
  { 
    id: 436, 
    name: "Independiente", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -34.635, 
    lng: -58.3651, 
    city: "Buenos Aires",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_Independiente_logo.svg"
  },
  { 
    id: 437, 
    name: "New England Revolution", 
    country: "USA", 
    league: "MLS", 
    lat: 42.3601, 
    lng: -71.0589, 
    city: "Boston",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/New_England_Revolution_logo.svg"
  },
  { 
    id: 438, 
    name: "Anderlecht", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8503, 
    lng: 4.3517, 
    city: "Brussels",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/RSC_Anderlecht_logo.svg"
  },
  { 
    id: 439, 
    name: "Ludogorets", 
    country: "Bulgaria", 
    league: "First League", 
    lat: 43.8564, 
    lng: 25.9569, 
    city: "Razgrad",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/PFC_Ludogorets_Razgrad_logo.svg"
  },
  { 
    id: 440, 
    name: "FC Midtjylland", 
    country: "Denmark", 
    league: "Superligaen", 
    lat: 56.1572, 
    lng: 9.8748, 
    city: "Herning",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Midtjylland_logo.svg"
  },
  { 
    id: 441, 
    name: "Monterrey", 
    country: "Mexico", 
    league: "Liga MX", 
    lat: 25.6866, 
    lng: -100.3161, 
    city: "Monterrey",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CF_Monterrey_logo.svg"
  },
  { 
    id: 442, 
    name: "Viktoria Plzen", 
    country: "Czech Republic", 
    league: "Fortuna Liga", 
    lat: 49.7475, 
    lng: 13.3776, 
    city: "Plzeň",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Viktoria_Plze%C5%88_logo.svg"
  },
  { 
    id: 443, 
    name: "AEK Athens", 
    country: "Greece", 
    league: "Super League", 
    lat: 37.9755, 
    lng: 23.7348, 
    city: "Athens",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AEK_Athens_FC_logo.svg"
  },
  { 
    id: 444, 
    name: "Braintree Town", 
    country: "England", 
    league: "National League South", 
    lat: 51.8787, 
    lng: 0.5506, 
    city: "Braintree",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Braintree_Town_FC_logo.svg"
  },
  { 
    id: 445, 
    name: "Charlotte FC", 
    country: "USA", 
    league: "MLS", 
    lat: 35.2271, 
    lng: -80.8431, 
    city: "Charlotte",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Charlotte_FC_logo.svg"
  },
  { 
    id: 446, 
    name: "Accrington", 
    country: "England", 
    league: "League Two", 
    lat: 53.7537, 
    lng: -2.3589, 
    city: "Accrington",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Accrington_Stanley_FC_logo.svg"
  },
  { 
    id: 447, 
    name: "PEC Zwolle", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 52.5167, 
    lng: 6.0833, 
    city: "Zwolle",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/PEC_Zwolle_logo.svg"
  },
  { 
    id: 448, 
    name: "Cesena", 
    country: "Italy", 
    league: "Serie C", 
    lat: 44.1391, 
    lng: 12.2431, 
    city: "Cesena",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AC_Cesena_logo.svg"
  },
  { 
    id: 449, 
    name: "Swansea", 
    country: "Wales", 
    league: "Championship", 
    lat: 51.6214, 
    lng: -3.9436, 
    city: "Swansea",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Swansea_City_AFC_logo.svg"
  },
  { 
    id: 450, 
    name: "Trabzonspor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 41.0015, 
    lng: 39.7178, 
    city: "Trabzon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Trabzonspor_logo.svg"
  },
  { 
    id: 451, 
    name: "Cádiz", 
    country: "Spain", 
    league: "La Liga", 
    lat: 36.5298, 
    lng: -6.2934, 
    city: "Cádiz",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/C%C3%A1diz_CF_logo.svg"
  },
  { 
    id: 452, 
    name: "Heracles Almelo", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 52.35, 
    lng: 6.6667, 
    city: "Almelo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Heracles_Almelo_logo.svg"
  },
  { 
    id: 453, 
    name: "Portsmouth", 
    country: "England", 
    league: "League One", 
    lat: 50.8198, 
    lng: -1.088, 
    city: "Portsmouth",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Portsmouth_FC_logo.svg"
  },
  { 
    id: 454, 
    name: "Ferencvaros", 
    country: "Hungary", 
    league: "NB I", 
    lat: 47.4814, 
    lng: 19.1461, 
    city: "Budapest",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Ferencv%C3%A1rosi_TC_logo.svg"
  },
  { 
    id: 455, 
    name: "Atlético Mineiro", 
    country: "Brazil", 
    league: "Série A", 
    lat: -19.9167, 
    lng: -43.9345, 
    city: "Belo Horizonte",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Clube_Atl%C3%A9tico_Mineiro_logo.svg"
  },
  { 
    id: 456, 
    name: "Lommel SK", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 51.2333, 
    lng: 5.3167, 
    city: "Lommel",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Lommel_SK_logo.svg"
  },
  { 
    id: 457, 
    name: "Racing Santander", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 43.4623, 
    lng: -3.8099, 
    city: "Santander",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Racing_de_Santander_logo.svg"
  },
  { 
    id: 458, 
    name: "Al-Ahli", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 21.4858, 
    lng: 39.1925, 
    city: "Jeddah",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Ahli_Saudi_FC_logo.svg"
  },
  { 
    id: 459, 
    name: "Livorno", 
    country: "Italy", 
    league: "Serie C", 
    lat: 43.55, 
    lng: 10.3167, 
    city: "Livorno",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/AS_Livorno_logo.svg"
  },
  { 
    id: 460, 
    name: "Lusitânia Lourosa", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 40.9833, 
    lng: -8.55, 
    city: "Lourosa",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Lusit%C3%A2nia_FC_Lourosa_logo.svg"
  },
  { 
    id: 461, 
    name: "Dundee", 
    country: "Scotland", 
    league: "Premiership", 
    lat: 56.462, 
    lng: -2.9707, 
    city: "Dundee",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Dundee_FC_logo.svg"
  },
  { 
    id: 462, 
    name: "Dundalk", 
    country: "Ireland", 
    league: "Premier Division", 
    lat: 54.0039, 
    lng: -6.4053, 
    city: "Dundalk",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Dundalk_FC_logo.svg"
  },
  { 
    id: 463, 
    name: "Bristol Rovers", 
    country: "England", 
    league: "League One", 
    lat: 51.4545, 
    lng: -2.5879, 
    city: "Bristol",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Bristol_Rovers_FC_logo.svg"
  },
  { 
    id: 464, 
    name: "Stockport County", 
    country: "England", 
    league: "League Two", 
    lat: 53.4108, 
    lng: -2.1575, 
    city: "Stockport",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Stockport_County_FC_logo.svg"
  },
  { 
    id: 465, 
    name: "WSG Tirol", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 47.2692, 
    lng: 11.4041, 
    city: "Innsbruck",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/WSG_Tirol_logo.svg"
  },
  { 
    id: 466, 
    name: "FCV Dender", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.8833, 
    lng: 4.1, 
    city: "Denderleeuw",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FCV_Dender_EH_logo.svg"
  },
  { 
    id: 467, 
    name: "HamKam", 
    country: "Norway", 
    league: "Eliteserien", 
    lat: 60.7945, 
    lng: 11.068, 
    city: "Hamar",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/HamKam_logo.svg"
  },
  { 
    id: 468, 
    name: "Middlesbrough", 
    country: "England", 
    league: "Championship", 
    lat: 54.5742, 
    lng: -1.2346, 
    city: "Middlesbrough",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Middlesbrough_FC_logo.svg"
  },
  { 
    id: 469, 
    name: "Moreirense", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 41.1, 
    lng: -8.25, 
    city: "Moreira de Cónegos",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Moreirense_FC_logo.svg"
  },
  { 
    id: 470, 
    name: "Plymouth Argyle", 
    country: "England", 
    league: "Championship", 
    lat: 50.3755, 
    lng: -4.1427, 
    city: "Plymouth",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Plymouth_Argyle_FC_logo.svg"
  },
  { 
    id: 471, 
    name: "Dundee United", 
    country: "Scotland", 
    league: "Championship", 
    lat: 56.462, 
    lng: -2.9707, 
    city: "Dundee",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Dundee_United_FC_logo.svg"
  },
  { 
    id: 472, 
    name: "Göztepe", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 38.4192, 
    lng: 27.1287, 
    city: "İzmir",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/G%C3%B6ztepe_SK_logo.svg"
  },
  { 
    id: 473, 
    name: "Sparta Rotterdam", 
    country: "Netherlands", 
    league: "Eredivisie", 
    lat: 51.9244, 
    lng: 4.4778, 
    city: "Rotterdam",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Sparta_Rotterdam_logo.svg"
  },
  { 
    id: 474, 
    name: "Cultural Leonesa", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 42.5987, 
    lng: -5.5671, 
    city: "León",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Cultural_y_Deportiva_Leonesa_logo.svg"
  },
  { 
    id: 475, 
    name: "Eyupspor", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 41.0082, 
    lng: 28.9784, 
    city: "Istanbul",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Ey%C3%BCpspor_logo.svg"
  },
  { 
    id: 476, 
    name: "São Paulo", 
    country: "Brazil", 
    league: "Série A", 
    lat: -23.5505, 
    lng: -46.6333, 
    city: "São Paulo",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/S%C3%A3o_Paulo_FC_logo.svg"
  },
  { 
    id: 477, 
    name: "Barrow", 
    country: "England", 
    league: "League Two", 
    lat: 54.1109, 
    lng: -3.2261, 
    city: "Barrow-in-Furness",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Barrow_AFC_logo.svg"
  },
  { 
    id: 478, 
    name: "Rio Ave", 
    country: "Portugal", 
    league: "Primeira Liga", 
    lat: 41.3667, 
    lng: -8.75, 
    city: "Vila do Conde",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Rio_Ave_FC_logo.svg"
  },
  { 
    id: 479, 
    name: "Kayserispor", 
    country: "Turkey", 
    league: "Süper Lig", 
    lat: 38.7312, 
    lng: 35.4787, 
    city: "Kayseri",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Kayserispor_logo.svg"
  },
  { 
    id: 480, 
    name: "Aris Limassol", 
    country: "Cyprus", 
    league: "First Division", 
    lat: 34.7071, 
    lng: 33.0226, 
    city: "Limassol",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Aris_Limassol_FC_logo.svg"
  },
  { 
    id: 481, 
    name: "Lincoln City", 
    country: "England", 
    league: "League One", 
    lat: 53.2307, 
    lng: -0.5409, 
    city: "Lincoln",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Lincoln_City_FC_logo.svg"
  },
  { 
    id: 482, 
    name: "San Luis", 
    country: "Mexico", 
    league: "Liga MX", 
    lat: 22.1565, 
    lng: -100.9855, 
    city: "San Luis Potosí",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Atl%C3%A9tico_San_Luis_logo.svg"
  },
  { 
    id: 483, 
    name: "Gimnàstic", 
    country: "Spain", 
    league: "Primera División RFEF", 
    lat: 41.1177, 
    lng: 1.25, 
    city: "Tarragona",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Gimn%C3%A0stic_de_Tarragona_logo.svg"
  },
  { 
    id: 484, 
    name: "Cartagena", 
    country: "Spain", 
    league: "Segunda División", 
    lat: 37.6, 
    lng: -0.9864, 
    city: "Cartagena",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Cartagena_logo.svg"
  },
  { 
    id: 485, 
    name: "Qarabag FK", 
    country: "Azerbaijan", 
    league: "Premier League", 
    lat: 40.4093, 
    lng: 49.8671, 
    city: "Baku",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Qaraba%C4%9F_FK_logo.svg"
  },
  { 
    id: 486, 
    name: "Panetolikos", 
    country: "Greece", 
    league: "Super League", 
    lat: 38.6333, 
    lng: 21.4167, 
    city: "Agrinio",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Panetolikos_FC_logo.svg"
  },
  { 
    id: 487, 
    name: "Leixões", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 41.1833, 
    lng: -8.7, 
    city: "Matosinhos",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Leix%C3%B5es_SC_logo.svg"
  },
  { 
    id: 488, 
    name: "Al-Shabab", 
    country: "Saudi Arabia", 
    league: "Saudi Pro League", 
    lat: 24.7136, 
    lng: 46.6753, 
    city: "Riyadh",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Al-Shabab_FC_logo.svg"
  },
  { 
    id: 489, 
    name: "Dijon", 
    country: "France", 
    league: "Ligue 2", 
    lat: 47.322, 
    lng: 5.0415, 
    city: "Dijon",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/DFCO_logo.svg"
  },
  { 
    id: 490, 
    name: "Südtirol", 
    country: "Italy", 
    league: "Serie B", 
    lat: 46.4983, 
    lng: 11.3548, 
    city: "Bolzano",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_S%C3%BCdtirol_logo.svg"
  },
  { 
    id: 491, 
    name: "Quevilly-Rouen", 
    country: "France", 
    league: "Ligue 2", 
    lat: 49.4432, 
    lng: 1.0993, 
    city: "Rouen",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Quevilly-Rouen_M%C3%A9tropole_logo.svg"
  },
  { 
    id: 492, 
    name: "Sampdoria", 
    country: "Italy", 
    league: "Serie B", 
    lat: 44.4056, 
    lng: 8.9463, 
    city: "Genoa",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/UC_Sampdoria_logo.svg"
  },
  { 
    id: 493, 
    name: "Amedspor", 
    country: "Turkey", 
    league: "TFF 1. Lig", 
    lat: 37.8667, 
    lng: 40.2333, 
    city: "Diyarbakır",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Amed_SK_logo.svg"
  },
  { 
    id: 494, 
    name: "Penafiel", 
    country: "Portugal", 
    league: "Liga 3", 
    lat: 41.2, 
    lng: -8.2833, 
    city: "Penafiel",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/FC_Penafiel_logo.svg"
  },
  { 
    id: 495, 
    name: "Charleroi", 
    country: "Belgium", 
    league: "Pro League", 
    lat: 50.4108, 
    lng: 4.4446, 
    city: "Charleroi",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Royal_Charleroi_SC_logo.svg"
  },
  { 
    id: 496, 
    name: "Ternana", 
    country: "Italy", 
    league: "Serie B", 
    lat: 42.5603, 
    lng: 12.6445, 
    city: "Terni",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Ternana_Calcio_logo.svg"
  },
  { 
    id: 497, 
    name: "Wolfsberger AC", 
    country: "Austria", 
    league: "Bundesliga", 
    lat: 46.8403, 
    lng: 14.8442, 
    city: "Wolfsberg",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Wolfsberger_AC_logo.svg"
  },
  { 
    id: 498, 
    name: "Club Atlético Belgrano", 
    country: "Argentina", 
    league: "Primera División", 
    lat: -31.4201, 
    lng: -64.1888, 
    city: "Córdoba",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/CA_Belgrano_logo.svg"
  },
  { 
    id: 499, 
    name: "Lechia Gdansk", 
    country: "Poland", 
    league: "Ekstraklasa", 
    lat: 54.352, 
    lng: 18.6466, 
    city: "Gdańsk",
    crest: "https://upload.wikimedia.org/wikipedia/en/4/4c/Lechia_Gda%C5%84sk_logo.svg"
  }
];

export const getClubById = (id) => clubs.find(club => club.id === id);
